/* eslint-disable */
import { useState, useEffect, Fragment, useRef } from 'react';
import { keuanganAPI } from '../services/api';
import { LoadingSpinner, ErrorBox, EmptyState } from '../components/LoadingSpinner';
import { proyekAPI } from '../services/api';
import { uploadAPI } from '../services/api';
import BtnExportPDF from '../components/BtnExportPDF';




// ============================================
// HELPERS
// ============================================

function useProyekList() {
  const [list, setList] = useState([]);
  useEffect(() => {
    proyekAPI.getAll().then(r => {
      if (r.ok) {
        const sorted = r.data.data
          .map(p => ({ id: p.id, kode: p.kode||'', nama: p.nama }))
          .sort((a,b) => a.nama.localeCompare(b.nama, 'id'));
        setList(sorted);
      }
    }).catch(()=>{});
    }, []);
    return list;
  }

function formatRp(n) {
  return 'Rp ' + Number(n||0).toLocaleString('id-ID');
}

function tglHariIni() {
  return new Date().toISOString().split('T')[0];
}

const inputStyle = {
  padding:'8px 10px', border:'1.5px solid #ddd', borderRadius:'8px',
  fontSize:'13px', color:'#333', background:'#fafafa',
  outline:'none', width:'100%', fontFamily:'inherit', boxSizing:'border-box'
};

function Badge({ status }) {
  const map = {
    paid:    { label:'✅ Lunas',   bg:'#eafaf1', color:'#27ae60' },
    partial: { label:'⚡ Sebagian', bg:'#fef5e7', color:'#e67e22' },
    unpaid:  { label:'❌ Belum',   bg:'#fdedec', color:'#e74c3c' },
    masuk:   { label:'▲ Masuk',   bg:'#eafaf1', color:'#27ae60' },
    keluar:  { label:'▼ Keluar',  bg:'#fdedec', color:'#e74c3c' },
  };
  const s = map[status] || { label: status, bg:'#f0f4f8', color:'#666' };
  return (
    <span style={{ display:'inline-block', padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:s.bg, color:s.color }}>
      {s.label}
    </span>
  );
}

function Modal({ show, onClose, title, children, footer }) {
  if (!show) return null;
  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:999, padding:'20px' }}>
      <div style={{ background:'white', borderRadius:'16px', width:'100%', maxWidth:'800px', maxHeight:'90vh', display:'flex', flexDirection:'column', boxShadow:'0 20px 60px rgba(0,0,0,0.3)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'16px 24px', borderBottom:'1px solid #f0f4f8' }}>
          <h3 style={{ fontSize:'15px', color:'#1a3a5c', margin:0 }}>{title}</h3>
          <button onClick={onClose} style={{ background:'none', border:'none', fontSize:'20px', cursor:'pointer', color:'#888' }}>✕</button>
        </div>
        <div style={{ padding:'20px', overflowY:'auto', flex:1, display:'flex', flexDirection:'column', gap:'14px' }}>
          {children}
        </div>
        {footer && (
          <div style={{ padding:'14px 20px', borderTop:'1px solid #f0f4f8', display:'flex', justifyContent:'flex-end', gap:'10px' }}>
            {footer}
          </div>
        )}
      </div>
    </div>
  );
}

function Btn({ onClick, color='biru', children, disabled }) {
  const colors = {
    biru:  { bg:'linear-gradient(135deg,#1a3a5c,#2d6a9f)', txt:'white' },
    hijau: { bg:'linear-gradient(135deg,#1e8449,#27ae60)',  txt:'white' },
    merah: { bg:'linear-gradient(135deg,#c0392b,#e74c3c)',  txt:'white' },
    abu:   { bg:'white', txt:'#333', border:'1.5px solid #ddd'          },
  };
  const c = colors[color];
  return (
    <button onClick={onClick} disabled={disabled} style={{ padding:'9px 16px', background:c.bg, color:c.txt, border:c.border||'none', borderRadius:'8px', fontSize:'13px', fontWeight:'600', cursor:disabled?'not-allowed':'pointer', opacity:disabled?0.6:1, whiteSpace:'nowrap' }}>
      {children}
    </button>
  );
}

function FG({ label, required, children, span }) {
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'6px', gridColumn: span?'1/-1':'auto' }}>
      <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>
        {label} {required && <span style={{ color:'#e74c3c' }}>*</span>}
      </label>
      {children}
    </div>
  );
}

function SelectProyekK({ value, onChange, list, placeholder = '-- Pilih Proyek --' }) {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const [pos, setPos]       = useState({ top:0, left:0, width:0 });
  const triggerRef = useRef(null);
  const dropRef    = useRef(null);

  const selected = list.find(p => String(p.id) === String(value));
  const filtered = list.filter(p =>
    !search ||
    p.nama.toLowerCase().includes(search.toLowerCase()) ||
    (p.kode||'').toLowerCase().includes(search.toLowerCase())
  );

  function bukaDropdown() {
    if (triggerRef.current) {
      const r = triggerRef.current.getBoundingClientRect();
      setPos({ top: r.bottom + 4, left: r.left, width: r.width });
    }
    setOpen(true);
  }

  useEffect(() => {
    function handleClickOutside(e) {
      if (triggerRef.current?.contains(e.target)) return;
      if (dropRef.current?.contains(e.target)) return;
      setOpen(false); setSearch('');
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <div ref={triggerRef} onClick={bukaDropdown} style={{ ...inputStyle, cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <span style={{ color: selected?'#333':'#aaa', fontSize:'13px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
          {selected ? (selected.kode ? `${selected.kode} · ${selected.nama}` : selected.nama) : placeholder}
        </span>
        <span style={{ fontSize:'10px', color:'#888', marginLeft:'6px' }}>▼</span>
      </div>

      {open && (
        <div ref={dropRef} style={{
          position:'fixed', top: pos.top, left: pos.left, width: pos.width,
          background:'white', border:'1px solid #ddd', borderRadius:'8px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.2)', zIndex:2000,
          maxHeight:'280px', display:'flex', flexDirection:'column'
        }}>
          <div style={{ padding:'8px', borderBottom:'1px solid #eee' }}>
            <input autoFocus value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Ketik kode atau nama proyek..." style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px' }} />
          </div>
          <div style={{ overflowY:'auto', flex:1 }}>
            <div
              onClick={() => { onChange(''); setOpen(false); setSearch(''); }}
              style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', color:'#aaa' }}
              onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
              onMouseLeave={e=>e.currentTarget.style.background='white'}
            >
              -- Kosongkan --
            </div>
            {filtered.length === 0 ? (
              <div style={{ padding:'12px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>Tidak ditemukan</div>
            ) : filtered.map(p => (
              <div key={p.id}
                onClick={() => { onChange(String(p.id)); setOpen(false); setSearch(''); }}
                style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', background: String(p.id)===String(value)?'#eaf0fb':'white' }}
                onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
                onMouseLeave={e=>e.currentTarget.style.background = String(p.id)===String(value) ? '#eaf0fb' : 'white'}
              >
                {p.kode && <strong>{p.kode}</strong>}{p.kode && ' · '}{p.nama}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

function SelectKasbon({ value, onChange, list, placeholder = '-- Tanpa referensi / manual --' }) {
  const [open, setOpen]     = useState(false);
  const [search, setSearch] = useState('');
  const [pos, setPos]       = useState({ top:0, left:0, width:0 });
  const triggerRef = useRef(null);
  const dropRef    = useRef(null);

  const selected = list.find(p => String(p.id) === String(value));
  const filtered = list.filter(p =>
    !search ||
    p.no_pengajuan.toLowerCase().includes(search.toLowerCase()) ||
    (p.nama_proyek||'').toLowerCase().includes(search.toLowerCase())
  );

  function bukaDropdown() {
    if (triggerRef.current) {
      const r = triggerRef.current.getBoundingClientRect();
      setPos({ top: r.bottom + 4, left: r.left, width: r.width });
    }
    setOpen(true);
  }

  useEffect(() => {
    function handleClickOutside(e) {
      if (triggerRef.current?.contains(e.target)) return;
      if (dropRef.current?.contains(e.target)) return;
      setOpen(false); setSearch('');
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <>
      <div ref={triggerRef} onClick={bukaDropdown} style={{ ...inputStyle, cursor:'pointer', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <span style={{ color: selected?'#333':'#aaa', fontSize:'12px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
          {selected ? `${selected.no_pengajuan} · ${selected.nama_proyek} · ${formatRp(selected.jumlah_total)}` : placeholder}
        </span>
        <span style={{ fontSize:'10px', color:'#888', marginLeft:'6px' }}>▼</span>
      </div>

      {open && (
        <div ref={dropRef} style={{
          position:'fixed', top: pos.top, left: pos.left, width: pos.width,
          background:'white', border:'1px solid #ddd', borderRadius:'8px',
          boxShadow:'0 8px 24px rgba(0,0,0,0.2)', zIndex:2000,
          maxHeight:'260px', display:'flex', flexDirection:'column'
        }}>
          <div style={{ padding:'8px', borderBottom:'1px solid #eee' }}>
            <input autoFocus value={search} onChange={e=>setSearch(e.target.value)} placeholder="🔍 Ketik no. pengajuan atau proyek..." style={{ ...inputStyle, padding:'6px 10px', fontSize:'12px' }} />
          </div>
          <div style={{ overflowY:'auto', flex:1 }}>
            <div
              onClick={() => { onChange(''); setOpen(false); setSearch(''); }}
              style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', color:'#aaa' }}
              onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
              onMouseLeave={e=>e.currentTarget.style.background='white'}
            >
              -- Tanpa referensi / manual --
            </div>
            {filtered.length === 0 ? (
              <div style={{ padding:'12px', fontSize:'12px', color:'#aaa', textAlign:'center' }}>
                Tidak ada pengajuan yang siap dilaporkan
              </div>
            ) : filtered.map(p => (
              <div key={p.id}
                onClick={() => { onChange(String(p.id)); setOpen(false); setSearch(''); }}
                style={{ padding:'8px 12px', fontSize:'12px', cursor:'pointer', background: String(p.id)===String(value)?'#eaf0fb':'white' }}
                onMouseEnter={e=>e.currentTarget.style.background='#f5f7fa'}
                onMouseLeave={e=>e.currentTarget.style.background = String(p.id)===String(value) ? '#eaf0fb' : 'white'}
              >
                <strong>{p.no_pengajuan}</strong> · {p.nama_proyek} · {formatRp(p.jumlah_total)}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

function KopFormulir({ judulFormulir, rows }) {
  const totalRows = rows.length; // biasanya 3: No.Dok, Revisi, Tgl Terbit

  return (
    <div style={{
      display:'grid',
      gridTemplateColumns:'80px 1.6fr 90px 1fr',
      gridTemplateRows: `repeat(${totalRows}, auto)`,
      border:'1.5px solid #000',
      fontFamily:'inherit', color:'#000', background:'white'
    }}>

      {/* LOGO — span semua baris */}
      <div style={{
        gridColumn:'1', gridRow:`1 / ${totalRows+1}`,
        borderRight:'1.5px solid #000',
        display:'flex', alignItems:'center', justifyContent:'center', padding:'4px'
      }}>
        <img src={`${process.env.PUBLIC_URL}/kop mkmj.jpg`} alt="Logo PT Mitra Karya Mandiri Jaya"
          style={{ width:'100%', height:'100%', objectFit:'contain' }} />
      </div>

      {/* NAMA PT — baris 1 saja */}
      <div style={{
        gridColumn:'2', gridRow:'1',
        borderRight:'1.5px solid #000', borderBottom:'1.5px solid #000',
        padding:'6px 12px', textAlign:'center',
        display:'flex', alignItems:'center', justifyContent:'center'
      }}>
        <span style={{ fontWeight:'700', fontSize:'13px' }}>PT. MITRA KARYA MANDIRI JAYA</span>
      </div>

      {/* JUDUL FORMULIR — span sisa baris */}
      <div style={{
        gridColumn:'2', gridRow:`2 / ${totalRows+1}`,
        borderRight:'1.5px solid #000',
        display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:'2px',
        padding:'6px 12px', textAlign:'center'
      }}>
        <div style={{ fontWeight:'700', fontSize:'13px' }}>FORMULIR</div>
        <div style={{ fontWeight:'700', fontSize:'13px', textTransform:'uppercase' }}>{judulFormulir}</div>
      </div>

      {/* KOLOM LABEL + VALUE — setiap baris satu item */}
      {rows.map(([label, value], i) => (
        <Fragment key={label || i}>
          <div key={`l-${label}`} style={{
            gridColumn:'3', gridRow: i+1,
            borderRight:'1px solid #000',
            borderBottom: i < totalRows-1 ? '1.5px solid #000' : 'none',
            padding:'4px 6px', fontSize:'11px',
            display:'flex', alignItems:'center'
          }}>
            {label}
          </div>
          <div key={`v-${label}`} style={{
            gridColumn:'4', gridRow: i+1,
            borderBottom: i < totalRows-1 ? '1.5px solid #000' : 'none',
            padding:'4px 6px', fontSize:'11px',
            display:'flex', alignItems:'center'
          }}>
            : {value}
          </div>
        </Fragment>
      ))}

    </div>
  );
}

// ============================================
// TAB: RINGKASAN / DASHBOARD KEUANGAN
// ============================================
function TabRingkasan() {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    keuanganAPI.getLaporanRingkasan()
      .then(r => { if (r.ok) setData(r.data.data); else setError(r.data.message); })
      .catch(() => setError('Gagal memuat laporan'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner pesan="Memuat laporan keuangan..." />;
  if (error)   return <ErrorBox pesan={error} />;
  if (!data)   return null;

  const persen = (real, ang) => ang > 0 ? Math.min(100, Math.round(real/ang*100)) : 0;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'20px' }}>

      {/* STAT CARDS */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(4,1fr)', gap:'16px' }}>
        {[
          { icon:'🏦', label:'Total Kas & Bank',    val: formatRp(data.total_kas),     bg:'linear-gradient(135deg,#1a3a5c,#2d6a9f)', sub: 'Saldo tersedia' },
          { icon:'📄', label:'Piutang Belum Lunas', val: formatRp(data.total_piutang), bg:'linear-gradient(135deg,#ca6f1e,#e67e22)', sub: 'Outstanding AR' },
          { icon:'▲',  label:'Pemasukan Bulan Ini', val: formatRp(data.trx_bulan.total_masuk),  bg:'linear-gradient(135deg,#1e8449,#27ae60)', sub: 'Total kas masuk' },
          { icon:'▼',  label:'Pengeluaran Bulan Ini',val: formatRp(data.trx_bulan.total_keluar), bg:'linear-gradient(135deg,#c0392b,#e74c3c)', sub: 'Total kas keluar' },
        ].map((s,i)=>(
          <div key={i} style={{ background:s.bg, borderRadius:'12px', padding:'20px', color:'white', display:'flex', flexDirection:'column', gap:'6px' }}>
            <span style={{ fontSize:'20px' }}>{s.icon}</span>
            <span style={{ fontSize:'22px', fontWeight:'700' }}>{s.val}</span>
            <span style={{ fontSize:'12px', opacity:0.85 }}>{s.label}</span>
            <span style={{ fontSize:'11px', opacity:0.7 }}>{s.sub}</span>
          </div>
        ))}
      </div>

      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'20px' }}>

        {/* ANGGARAN VS REALISASI */}
        <div style={{ background:'white', borderRadius:'12px', padding:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c', marginBottom:'16px', marginTop:0 }}>
            📊 Anggaran vs Realisasi per Proyek
          </h3>
          <div style={{ display:'flex', flexDirection:'column', gap:'14px' }}>
            {data.anggaran.map((a,i)=>{
              const p = persen(a.total_realisasi, a.total_anggaran);
              const over = Number(a.total_realisasi) > Number(a.total_anggaran);
              return (
                <div key={i}>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'4px' }}>
                    <span style={{ fontSize:'12px', fontWeight:'600', color:'#333' }}>{a.nama_proyek}</span>
                    <span style={{ fontSize:'11px', color: over?'#e74c3c':'#666' }}>
                      {formatRp(a.total_realisasi)} / {formatRp(a.total_anggaran)}
                    </span>
                  </div>
                  <div style={{ background:'#f0f4f8', borderRadius:'99px', height:'8px', overflow:'auto' }}>
                    <div style={{ width:`${p}%`, height:'100%', background: over?'#e74c3c': p>80?'#e67e22':'#27ae60', borderRadius:'99px', transition:'width 0.5s' }} />
                  </div>
                  <div style={{ display:'flex', justifyContent:'space-between', marginTop:'2px' }}>
                    <span style={{ fontSize:'10px', color:'#888' }}>Realisasi: {p}%</span>
                    <span style={{ fontSize:'10px', color: over?'#e74c3c':'#27ae60', fontWeight:'600' }}>
                      {over ? `Over ${formatRp(a.total_realisasi-a.total_anggaran)}` : `Sisa ${formatRp(a.total_anggaran-a.total_realisasi)}`}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        {/* TREND KAS 6 BULAN */}
        <div style={{ background:'white', borderRadius:'12px', padding:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
          <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c', marginBottom:'16px', marginTop:0 }}>
            📈 Trend Kas 6 Bulan Terakhir
          </h3>
          {data.trend_kas.length === 0 ? (
            <EmptyState icon="📈" judul="Belum ada data" sub="Belum ada transaksi 6 bulan terakhir" />
          ) : (
            <div style={{ display:'flex', flexDirection:'column', gap:'10px' }}>
              {data.trend_kas.map((t,i)=>{
                const maxVal = Math.max(...data.trend_kas.map(x=>Math.max(Number(x.masuk),Number(x.keluar))));
                const pMasuk  = maxVal > 0 ? (Number(t.masuk)/maxVal*100)  : 0;
                const pKeluar = maxVal > 0 ? (Number(t.keluar)/maxVal*100) : 0;
                return (
                  <div key={i}>
                    <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'4px' }}>
                      <span style={{ fontSize:'11px', fontWeight:'600', color:'#666' }}>{t.bulan}</span>
                      <span style={{ fontSize:'11px', color:'#888' }}>
                        <span style={{ color:'#27ae60' }}>▲{formatRp(t.masuk)}</span>
                        {' / '}
                        <span style={{ color:'#e74c3c' }}>▼{formatRp(t.keluar)}</span>
                      </span>
                    </div>
                    <div style={{ display:'flex', gap:'4px', height:'12px' }}>
                      <div style={{ flex:1, background:'#f0f4f8', borderRadius:'4px', overflow:'auto' }}>
                        <div style={{ width:`${pMasuk}%`, height:'100%', background:'#27ae60', borderRadius:'4px' }} />
                      </div>
                      <div style={{ flex:1, background:'#f0f4f8', borderRadius:'4px', overflow:'auto' }}>
                        <div style={{ width:`${pKeluar}%`, height:'100%', background:'#e74c3c', borderRadius:'4px' }} />
                      </div>
                    </div>
                  </div>
                );
              })}
              <div style={{ display:'flex', gap:'16px', marginTop:'8px' }}>
                <span style={{ fontSize:'11px', color:'#27ae60' }}>■ Masuk</span>
                <span style={{ fontSize:'11px', color:'#e74c3c' }}>■ Keluar</span>
              </div>
            </div>
          )}
        </div>

      </div>
    </div>
  );
}

// ============================================
// TAB: KAS & BANK
// ============================================
function TabKasBank({ user }) {
  const [kasList, setKasList]   = useState([]);
  const [trxList, setTrxList]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [filterKas, setFilterKas] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    kas_bank_id:'', tipe:'masuk', kategori:'',
    tanggal: tglHariIni(), jumlah:'', keterangan:'', referensi:''
  });

  useEffect(() => { fetchData(); }, [filterKas]);

  async function fetchData() {
    setLoading(true);
    try {
      const [kasRes, trxRes] = await Promise.all([
        keuanganAPI.getAllKasBank(),
        keuanganAPI.getTransaksi(filterKas ? { kas_bank_id: filterKas } : {}),
      ]);
      if (kasRes.ok) setKasList(kasRes.data.data);
      if (trxRes.ok) setTrxList(trxRes.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  function handleChange(e) { setForm({...form,[e.target.name]:e.target.value}); }

  async function submitTrx() {
    if (!form.kas_bank_id||!form.jumlah||!form.tanggal) { alert('⚠️ Kas/Bank, jumlah, tanggal wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = await keuanganAPI.createTransaksi({
        kas_bank_id: Number(form.kas_bank_id),
        tipe:        form.tipe,
        kategori:    form.kategori,
        tanggal:     form.tanggal,
        jumlah:      Number(form.jumlah),
        keterangan:  form.keterangan,
        referensi:   form.referensi,
      });
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setForm({ kas_bank_id:'', tipe:'masuk', kategori:'', tanggal:tglHariIni(), jumlah:'', keterangan:'', referensi:'' });
        fetchData();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  const totalSaldo = kasList.reduce((s,k) => s + Number(k.saldo||0), 0);

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

      {/* KARTU KAS & BANK */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(200px,1fr))', gap:'12px' }}>
        {kasList.map((k,i)=>(
          <div key={i} onClick={()=>setFilterKas(filterKas===String(k.id)?'':String(k.id))}
            style={{ background: filterKas===String(k.id)?'#1a3a5c':'white', color: filterKas===String(k.id)?'white':'#333',
              borderRadius:'12px', padding:'16px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', cursor:'pointer',
              border: filterKas===String(k.id)?'2px solid #2d6a9f':'2px solid transparent', transition:'all 0.2s'
            }}>
            <div style={{ fontSize:'11px', fontWeight:'700', opacity:0.7, marginBottom:'4px' }}>
              {k.tipe==='bank'?'🏦':'💵'} {k.kode}
            </div>
            <div style={{ fontSize:'14px', fontWeight:'700', marginBottom:'2px' }}>{k.nama}</div>
            <div style={{ fontSize:'18px', fontWeight:'700', color: filterKas===String(k.id)?'#7ec8e3':'#1a3a5c' }}>
              {formatRp(k.saldo)}
            </div>
            {k.no_rekening && <div style={{ fontSize:'11px', opacity:0.6, marginTop:'4px' }}>{k.no_rekening}</div>}
          </div>
        ))}
        <div style={{ background:'linear-gradient(135deg,#6c3483,#8e44ad)', color:'white', borderRadius:'12px', padding:'16px', display:'flex', flexDirection:'column', justifyContent:'center' }}>
          <div style={{ fontSize:'11px', fontWeight:'700', opacity:0.7, marginBottom:'4px' }}>💰 TOTAL</div>
          <div style={{ fontSize:'18px', fontWeight:'700' }}>{formatRp(totalSaldo)}</div>
          <div style={{ fontSize:'11px', opacity:0.7, marginTop:'4px' }}>Semua rekening</div>
        </div>
      </div>

      {/* TOOLBAR */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <div style={{ display:'flex', gap:'10px', alignItems:'center' }}>
          <span style={{ fontSize:'13px', color:'#666' }}>
            {filterKas ? `Filter: ${kasList.find(k=>k.id===Number(filterKas))?.nama}` : 'Semua Rekening'}
          </span>
          {filterKas && <button onClick={()=>setFilterKas('')} style={{ background:'none', border:'none', color:'#e74c3c', cursor:'pointer', fontSize:'12px' }}>✕ Reset</button>}
        </div>
        <Btn onClick={()=>setShowForm(true)}>+ Catat Transaksi</Btn>
      </div>

      {/* TABEL TRANSAKSI */}
      {loading ? <LoadingSpinner pesan="Memuat transaksi..." /> : (
        trxList.length === 0
          ? <EmptyState icon="💰" judul="Belum ada transaksi" sub="Klik '+ Catat Transaksi' untuk mencatat" />
          : (
            <div style={{ background:'white', borderRadius:'12px', overflow:'auto', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead>
                  <tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                    {['No. Transaksi','Tanggal','Rekening','Tipe','Kategori','Jumlah','Keterangan','Referensi'].map(h=>(
                      <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'10px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {trxList.map(t=>(
                    <tr key={t.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                      <td style={{ padding:'12px', fontSize:'13px' }}><strong>{t.no_transaksi}</strong></td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>{t.tanggal?.split('T')[0]}</td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>{t.nama_kas}</td>
                      <td style={{ padding:'12px' }}><Badge status={t.tipe} /></td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>{t.kategori||'-'}</td>
                      <td style={{ padding:'12px', fontSize:'13px', fontWeight:'700', color: t.tipe==='masuk'?'#27ae60':'#e74c3c' }}>
                        {t.tipe==='masuk'?'+ ':'- '}{formatRp(t.jumlah)}
                      </td>
                      <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{t.keterangan||'-'}</td>
                      <td style={{ padding:'12px', fontSize:'12px', color:'#2d6a9f' }}>{t.referensi||'-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )
      )}

      {/* MODAL CATAT TRANSAKSI */}
      <Modal show={showForm} onClose={()=>setShowForm(false)} title="💰 Catat Transaksi Kas/Bank"
        footer={<>
          <Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn>
          <Btn onClick={submitTrx} disabled={submitting}>{submitting?'⏳...':'✅ Simpan'}</Btn>
        </>}
      >
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Rekening <span style={{ color:'#e74c3c' }}>*</span></label>
            <select name="kas_bank_id" value={form.kas_bank_id} onChange={handleChange} style={inputStyle}>
              <option value="">-- Pilih Rekening --</option>
              {kasList.map(k=><option key={k.id} value={k.id}>{k.nama} ({formatRp(k.saldo)})</option>)}
            </select>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Tipe <span style={{ color:'#e74c3c' }}>*</span></label>
            <select name="tipe" value={form.tipe} onChange={handleChange} style={inputStyle}>
              <option value="masuk">▲ Kas Masuk</option>
              <option value="keluar">▼ Kas Keluar</option>
            </select>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Tanggal <span style={{ color:'#e74c3c' }}>*</span></label>
            <input type="date" name="tanggal" value={form.tanggal} onChange={handleChange} style={inputStyle} />
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Jumlah (Rp) <span style={{ color:'#e74c3c' }}>*</span></label>
            <input type="number" name="jumlah" value={form.jumlah} onChange={handleChange} placeholder="0" style={inputStyle} />
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Kategori</label>
            <select name="kategori" value={form.kategori} onChange={handleChange} style={inputStyle}>
              <option value="">-- Pilih --</option>
              <option value="Pembayaran Klien">Pembayaran Klien</option>
              <option value="Pembayaran Vendor">Pembayaran Vendor</option>
              <option value="Gaji & Upah">Gaji & Upah</option>
              <option value="Operasional">Operasional</option>
              <option value="Pajak">Pajak</option>
              <option value="Investasi">Investasi</option>
              <option value="Lainnya">Lainnya</option>
            </select>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Referensi</label>
            <input name="referensi" value={form.referensi} onChange={handleChange} placeholder="No. Invoice, PO, dll" style={inputStyle} />
          </div>
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
          <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Keterangan</label>
          <textarea name="keterangan" value={form.keterangan} onChange={handleChange} rows="3"
            placeholder="Deskripsi transaksi..." style={{ ...inputStyle, resize:'vertical' }} />
        </div>
      </Modal>
    </div>
  );
}

// ============================================
// TAB: INVOICE / FAKTUR
// ============================================
function TabInvoice({ user }) {
  const [invList, setInvList]   = useState([]);
  const [kasList, setKasList]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [showBayar, setShowBayar] = useState(null);
  const [showDetail, setShowDetail] = useState(null);
  const [filterStatus, setFilterStatus] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const proyekList = useProyekList();

  const itemKosong = { deskripsi:'', qty:'1', satuan:'', harga:'' };
  const [form, setForm] = useState({
    tipe:'ar', proyek_id:'', nama_klien:'', alamat_klien:'',
    tanggal_invoice: tglHariIni(), tanggal_jatuh:'',
    ppn_persen:'11', catatan:'',
    items:[{ ...itemKosong }]
  });

  const [formBayar, setFormBayar] = useState({
    kas_bank_id:'', tanggal: tglHariIni(), jumlah:'', metode:'transfer', referensi:'', catatan:''
  });

  useEffect(() => { fetchData(); }, [filterStatus]);

  async function fetchData() {
    setLoading(true);
    try {
      const [invRes, kasRes] = await Promise.all([
        keuanganAPI.getAllInvoice(filterStatus ? { status: filterStatus } : {}),
        keuanganAPI.getAllKasBank(),
      ]);
      if (invRes.ok) setInvList(invRes.data.data);
      if (kasRes.ok) setKasList(kasRes.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  function handleChange(e) { setForm({...form,[e.target.name]:e.target.value}); }
  function updateItem(idx,field,value) { setForm({...form,items:form.items.map((it,i)=>i===idx?{...it,[field]:value}:it)}); }
  function tambahItem() { setForm({...form,items:[...form.items,{...itemKosong}]}); }
  function hapusItem(idx) { setForm({...form,items:form.items.filter((_,i)=>i!==idx)}); }

  const subtotalForm = form.items.reduce((s,i)=>s+Number(i.qty||0)*Number(i.harga||0),0);
  const ppnForm      = subtotalForm * (Number(form.ppn_persen||0)/100);
  const totalForm    = subtotalForm + ppnForm;

  async function submitInvoice() {
    if (!form.nama_klien||!form.items[0].deskripsi){alert('⚠️ Klien dan item wajib diisi!');return;}
    setSubmitting(true);
    try {
      const result = await keuanganAPI.createInvoice({
        ...form,
        proyek_id: form.proyek_id ? Number(form.proyek_id) : null,
        items: form.items.filter(i=>i.deskripsi),
      });
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setForm({ tipe:'ar', proyek_id:'', nama_klien:'', alamat_klien:'', tanggal_invoice:tglHariIni(), tanggal_jatuh:'', ppn_persen:'11', catatan:'', items:[{...itemKosong}] });
        fetchData();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  async function submitBayar() {
    if (!formBayar.kas_bank_id||!formBayar.jumlah){alert('⚠️ Rekening dan jumlah wajib diisi!');return;}
    setSubmitting(true);
    try {
      const result = await keuanganAPI.bayarInvoice(showBayar.id, {
        ...formBayar,
        kas_bank_id: Number(formBayar.kas_bank_id),
        jumlah:      Number(formBayar.jumlah),
      });
      if (result.ok) {
        alert(`✅ Pembayaran berhasil dicatat! Status: ${result.data.status}`);
        setShowBayar(null);
        setFormBayar({ kas_bank_id:'', tanggal:tglHariIni(), jumlah:'', metode:'transfer', referensi:'', catatan:'' });
        fetchData();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  
  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

      {/* TOOLBAR */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} style={{ ...inputStyle, maxWidth:'180px' }}>
          <option value="">Semua Status</option>
          <option value="unpaid">Belum Lunas</option>
          <option value="partial">Sebagian</option>
          <option value="paid">Lunas</option>
        </select>
        <Btn onClick={()=>setShowForm(true)}>+ Buat Invoice</Btn>
      </div>

      {/* TABEL INVOICE */}
      {loading ? <LoadingSpinner pesan="Memuat invoice..." /> : (
        invList.length === 0
          ? <EmptyState icon="📄" judul="Belum ada invoice" sub="Klik '+ Buat Invoice' untuk membuat faktur" />
          : (
            <div style={{ background:'white', borderRadius:'12px', overflow:'auto', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead>
                  <tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                    {['No. Invoice','Tgl Invoice','Klien','Proyek','Total','Terbayar','Sisa','Jatuh Tempo','Status','Aksi'].map(h=>(
                      <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'10px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {invList.map(inv=>{
                    const overdue = inv.status!=='paid' && new Date(inv.tanggal_jatuh) < new Date();
                    return (
                      <tr key={inv.id} style={{ borderBottom:'1px solid #f5f7fa', background: overdue?'#fff8f8':'white' }}>
                        <td style={{ padding:'12px' }}>
                          <button onClick={()=>setShowDetail(inv)} style={{ background:'none', border:'none', color:'#2d6a9f', fontWeight:'700', fontSize:'13px', cursor:'pointer', textDecoration:'underline' }}>
                            {inv.no_invoice}
                          </button>
                        </td>
                        <td style={{ padding:'12px', fontSize:'12px' }}>{inv.tanggal_invoice?.split('T')[0]}</td>
                        <td style={{ padding:'12px', fontSize:'12px', fontWeight:'500' }}>{inv.nama_klien}</td>
                        <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{inv.nama_proyek||'-'}</td>
                        <td style={{ padding:'12px', fontSize:'13px', fontWeight:'600' }}>{formatRp(inv.total)}</td>
                        <td style={{ padding:'12px', fontSize:'13px', color:'#27ae60', fontWeight:'600' }}>{formatRp(inv.terbayar)}</td>
                        <td style={{ padding:'12px', fontSize:'13px', color: Number(inv.sisa)>0?'#e74c3c':'#27ae60', fontWeight:'600' }}>{formatRp(inv.sisa)}</td>
                        <td style={{ padding:'12px', fontSize:'12px', color: overdue?'#e74c3c':'#666', fontWeight: overdue?'700':'400' }}>
                          {inv.tanggal_jatuh?.split('T')[0]||'-'}
                          {overdue && ' ⚠️'}
                        </td>
                        <td style={{ padding:'12px' }}><Badge status={inv.status} /></td>
                        <td style={{ padding:'12px' }}>
                          {inv.status !== 'paid' && (
                            <button onClick={()=>{ setShowBayar(inv); setFormBayar({...formBayar, jumlah: String(inv.sisa)}); }}
                              style={{ padding:'5px 12px', background:'#eafaf1', color:'#27ae60', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>
                              💳 Bayar
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )
      )}

      {/* MODAL FORM INVOICE */}
      <Modal show={showForm} onClose={()=>setShowForm(false)} title="📄 Buat Invoice / Faktur"
        footer={<>
          <Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn>
          <Btn onClick={submitInvoice} disabled={submitting}>{submitting?'⏳...':'✅ Simpan Invoice'}</Btn>
        </>}
      >
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Nama Klien *</label>
            <input name="nama_klien" value={form.nama_klien} onChange={handleChange} placeholder="Nama klien / pemberi kerja" style={inputStyle} />
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Proyek</label>
            <select name="proyek_id" value={form.proyek_id} onChange={handleChange} style={inputStyle}>
              <option value="">-- Pilih Proyek --</option>
              {proyekList.map(p=><option key={p.id} value={p.id}>{p.nama}</option>)}
            </select>
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Tgl Invoice *</label>
            <input type="date" name="tanggal_invoice" value={form.tanggal_invoice} onChange={handleChange} style={inputStyle} />
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Jatuh Tempo</label>
            <input type="date" name="tanggal_jatuh" value={form.tanggal_jatuh} onChange={handleChange} style={inputStyle} />
          </div>
          <div style={{ display:'flex', flexDirection:'column', gap:'6px', gridColumn:'1/-1' }}>
            <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Alamat Klien</label>
            <input name="alamat_klien" value={form.alamat_klien} onChange={handleChange} placeholder="Alamat lengkap klien" style={inputStyle} />
          </div>
        </div>

        {/* TABEL ITEM INVOICE */}
        <div>
          <label style={{ fontSize:'12px', fontWeight:'700', color:'#555', display:'block', marginBottom:'8px' }}>Item / Pekerjaan *</label>
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', minWidth:'500px' }}>
              <thead>
                <tr style={{ background:'#f0f4f8' }}>
                  {['No.','Deskripsi','Qty','Satuan','Harga Satuan','Jumlah',''].map(h=>(
                    <th key={h} style={{ padding:'8px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {form.items.map((item,idx)=>(
                  <tr key={idx}>
                    <td style={{ border:'1px solid #ddd', padding:'4px', textAlign:'center', fontSize:'12px', fontWeight:'700', color:'#666', width:'32px' }}>{idx+1}</td>
                    <td style={{ border:'1px solid #ddd', padding:'4px' }}>
                      <input value={item.deskripsi} onChange={e=>updateItem(idx,'deskripsi',e.target.value)} placeholder="Deskripsi pekerjaan" style={{ ...inputStyle, border:'none', background:'transparent', padding:'4px 6px' }} />
                    </td>
                    <td style={{ border:'1px solid #ddd', padding:'4px', width:'60px' }}>
                      <input type="number" value={item.qty} onChange={e=>updateItem(idx,'qty',e.target.value)} placeholder="1" style={{ ...inputStyle, border:'none', background:'transparent', padding:'4px 6px', textAlign:'center' }} />
                    </td>
                    <td style={{ border:'1px solid #ddd', padding:'4px', width:'70px' }}>
                      <input value={item.satuan} onChange={e=>updateItem(idx,'satuan',e.target.value)} placeholder="ls, m²" style={{ ...inputStyle, border:'none', background:'transparent', padding:'4px 6px', textAlign:'center' }} />
                    </td>
                    <td style={{ border:'1px solid #ddd', padding:'4px', width:'130px' }}>
                      <input type="number" value={item.harga} onChange={e=>updateItem(idx,'harga',e.target.value)} placeholder="0" style={{ ...inputStyle, border:'none', background:'transparent', padding:'4px 6px', textAlign:'right' }} />
                    </td>
                    <td style={{ border:'1px solid #ddd', padding:'6px', textAlign:'right', fontWeight:'600', color:'#1a3a5c', width:'120px', fontSize:'12px', background:'#f8fbff' }}>
                      {formatRp(Number(item.qty||0)*Number(item.harga||0))}
                    </td>
                    <td style={{ border:'1px solid #ddd', padding:'4px', width:'32px', textAlign:'center' }}>
                      {form.items.length>1 && <button onClick={()=>hapusItem(idx)} style={{ background:'none', border:'none', cursor:'pointer', fontSize:'14px', opacity:0.4 }}>🗑️</button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <button onClick={tambahItem} style={{ marginTop:'8px', padding:'5px 14px', background:'white', border:'1.5px dashed #2d6a9f', borderRadius:'6px', fontSize:'12px', color:'#2d6a9f', cursor:'pointer', fontWeight:'600' }}>
            + Tambah Item
          </button>
        </div>

        {/* SUMMARY */}
        <div style={{ background:'#f8fbff', borderRadius:'10px', padding:'14px', border:'1px solid #e0e8f4' }}>
          <div style={{ display:'flex', flexDirection:'column', gap:'8px' }}>
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:'13px' }}>
              <span>Subtotal:</span>
              <strong>{formatRp(subtotalForm)}</strong>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', fontSize:'13px' }}>
              <div style={{ display:'flex', alignItems:'center', gap:'8px' }}>
                <span>PPN:</span>
                <input type="number" name="ppn_persen" value={form.ppn_persen} onChange={handleChange}
                  style={{ ...inputStyle, width:'60px', padding:'4px 8px', fontSize:'12px' }} />
                <span>%</span>
              </div>
              <strong>{formatRp(ppnForm)}</strong>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:'15px', fontWeight:'700', color:'#1a3a5c', borderTop:'1px solid #ddd', paddingTop:'8px' }}>
              <span>TOTAL:</span>
              <span>{formatRp(totalForm)}</span>
            </div>
          </div>
        </div>
      </Modal>

      {/* MODAL BAYAR */}
      <Modal show={!!showBayar} onClose={()=>setShowBayar(null)} title={`💳 Bayar Invoice — ${showBayar?.no_invoice}`}
        footer={<>
          <Btn color="abu" onClick={()=>setShowBayar(null)} disabled={submitting}>Batal</Btn>
          <Btn color="hijau" onClick={submitBayar} disabled={submitting}>{submitting?'⏳...':'✅ Konfirmasi Pembayaran'}</Btn>
        </>}
      >
        {showBayar && (
          <div style={{ display:'flex', flexDirection:'column', gap:'14px' }}>
            <div style={{ background:'#f8fbff', borderRadius:'10px', padding:'14px', border:'1px solid #e0e8f4' }}>
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'8px' }}>
                <span style={{ fontSize:'13px', color:'#666' }}>Total Invoice:</span>
                <strong>{formatRp(showBayar.total)}</strong>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'8px' }}>
                <span style={{ fontSize:'13px', color:'#27ae60' }}>Sudah Terbayar:</span>
                <strong style={{ color:'#27ae60' }}>{formatRp(showBayar.terbayar)}</strong>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', borderTop:'1px solid #ddd', paddingTop:'8px' }}>
                <span style={{ fontSize:'14px', fontWeight:'700', color:'#e74c3c' }}>Sisa Tagihan:</span>
                <strong style={{ fontSize:'14px', color:'#e74c3c' }}>{formatRp(showBayar.sisa)}</strong>
              </div>
            </div>

            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Rekening Tujuan *</label>
                <select name="kas_bank_id" value={formBayar.kas_bank_id} onChange={e=>setFormBayar({...formBayar,kas_bank_id:e.target.value})} style={inputStyle}>
                  <option value="">-- Pilih Rekening --</option>
                  {kasList.map(k=><option key={k.id} value={k.id}>{k.nama}</option>)}
                </select>
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Tanggal Bayar *</label>
                <input type="date" value={formBayar.tanggal} onChange={e=>setFormBayar({...formBayar,tanggal:e.target.value})} style={inputStyle} />
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Jumlah Dibayar (Rp) *</label>
                <input type="number" value={formBayar.jumlah} onChange={e=>setFormBayar({...formBayar,jumlah:e.target.value})} placeholder="0" style={inputStyle} />
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Metode</label>
                <select value={formBayar.metode} onChange={e=>setFormBayar({...formBayar,metode:e.target.value})} style={inputStyle}>
                  <option value="transfer">🏦 Transfer</option>
                  <option value="tunai">💵 Tunai</option>
                  <option value="cek">📝 Cek/Giro</option>
                </select>
              </div>
            </div>
            <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
              <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Referensi / No. Transfer</label>
              <input value={formBayar.referensi} onChange={e=>setFormBayar({...formBayar,referensi:e.target.value})} placeholder="No. bukti transfer, dll" style={inputStyle} />
            </div>
          </div>
        )}
      </Modal>

      {/* MODAL DETAIL INVOICE */}
      <Modal show={!!showDetail} onClose={()=>setShowDetail(null)} title={`Detail Invoice — ${showDetail?.no_invoice}`}
        footer={<Btn color="abu" onClick={()=>setShowDetail(null)}>Tutup</Btn>}
      >
        {showDetail && (
          <div style={{ display:'flex', flexDirection:'column', gap:'14px' }}>
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px' }}>
              {[['No. Invoice',showDetail.no_invoice],['Tanggal',showDetail.tanggal_invoice?.split('T')[0]],['Klien',showDetail.nama_klien],['Proyek',showDetail.nama_proyek||'-'],['Jatuh Tempo',showDetail.tanggal_jatuh?.split('T')[0]||'-'],['Status','']].map(([l,v],i)=>(
                <div key={i}>
                  <p style={{ fontSize:'11px', color:'#888', fontWeight:'700', margin:'0 0 2px' }}>{l}</p>
                  {l==='Status' ? <Badge status={showDetail.status} /> : <p style={{ fontSize:'13px', margin:0 }}>{v||'-'}</p>}
                </div>
              ))}
            </div>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr style={{ background:'#f0f4f8' }}>
                {['No.','Deskripsi','Qty','Satuan','Harga','Jumlah'].map(h=>(
                  <th key={h} style={{ padding:'8px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center' }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {(showDetail.items||[]).map((it,i)=>(
                  <tr key={i}>
                    <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'center', fontSize:'12px' }}>{i+1}</td>
                    <td style={{ border:'1px solid #ddd', padding:'8px', fontSize:'12px' }}>{it.deskripsi}</td>
                    <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'center', fontSize:'12px' }}>{it.qty}</td>
                    <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'center', fontSize:'12px' }}>{it.satuan}</td>
                    <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'right', fontSize:'12px' }}>{formatRp(it.harga)}</td>
                    <td style={{ border:'1px solid #ddd', padding:'8px', textAlign:'right', fontSize:'13px', fontWeight:'600', color:'#1a3a5c' }}>{formatRp(it.jumlah)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div style={{ background:'#f8fbff', borderRadius:'10px', padding:'14px', border:'1px solid #e0e8f4' }}>
              {[['Subtotal',showDetail.subtotal],['PPN',showDetail.ppn],['TOTAL',showDetail.total],['Terbayar',showDetail.terbayar],['Sisa',showDetail.sisa]].map(([l,v],i)=>(
                <div key={i} style={{ display:'flex', justifyContent:'space-between', padding: i===2?'8px 0':'4px 0', borderTop: i===2?'1px solid #ddd':'none', marginTop: i===2?'4px':'0' }}>
                  <span style={{ fontSize: i===2||i===4?'14px':'13px', fontWeight: i===2||i===4?'700':'400', color: i===4&&Number(v)>0?'#e74c3c':i===3?'#27ae60':'#333' }}>{l}:</span>
                  <strong style={{ fontSize: i===2||i===4?'14px':'13px', color: i===4&&Number(v)>0?'#e74c3c':i===3?'#27ae60':i===2?'#1a3a5c':'#333' }}>{formatRp(v)}</strong>
                </div>
              ))}
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
}

// ============================================
// TAB: ANGGARAN & BUDGET
// ============================================
function TabAnggaran({ user }) {
  const [anggaranList, setAnggaranList] = useState([]);
  const [loading, setLoading]           = useState(true);
  const [filterProyek, setFilterProyek] = useState('');
  const [showForm, setShowForm]         = useState(false);
  const [submitting, setSubmitting]     = useState(false);
  const proyekList = useProyekList();
  

  const [form, setForm] = useState({
    proyek_id:'', kategori:'', sub_kategori:'', anggaran:'', periode: new Date().getFullYear().toString(), catatan:''
  });

  
  useEffect(() => { fetchData(); }, [filterProyek]);

  async function fetchData() {
    setLoading(true);
    try {
      const result = await keuanganAPI.getAllAnggaran(filterProyek ? { proyek_id: filterProyek } : {});
      if (result.ok) setAnggaranList(result.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  function handleChange(e) { setForm({...form,[e.target.name]:e.target.value}); }

  async function submitAnggaran() {
    if (!form.proyek_id||!form.kategori||!form.anggaran){alert('⚠️ Proyek, kategori, dan anggaran wajib diisi!');return;}
    setSubmitting(true);
    try {
      const result = await keuanganAPI.createAnggaran({...form, proyek_id: Number(form.proyek_id)});
      if (result.ok) {
        alert('✅ Anggaran berhasil ditambahkan!');
        setShowForm(false);
        setForm({ proyek_id:'', kategori:'', sub_kategori:'', anggaran:'', periode:new Date().getFullYear().toString(), catatan:'' });
        fetchData();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  // Grouping per proyek
  const byProyek = {};
  anggaranList.forEach(a => {
    const key = a.nama_proyek || 'Tanpa Proyek';
    if (!byProyek[key]) byProyek[key] = [];
    byProyek[key].push(a);
  });

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <select value={filterProyek} onChange={e=>setFilterProyek(e.target.value)} style={{ ...inputStyle, maxWidth:'200px' }}>
          <option value="">Semua Proyek</option>
          {proyekList.map(p=><option key={p.id} value={p.id}>{p.nama}</option>)}
        </select>
        <Btn onClick={()=>setShowForm(true)}>+ Tambah Anggaran</Btn>
      </div>

      {loading ? <LoadingSpinner pesan="Memuat data anggaran..." /> : (
        Object.keys(byProyek).length === 0
          ? <EmptyState icon="📊" judul="Belum ada anggaran" sub="Klik '+ Tambah Anggaran' untuk menambahkan" />
          : Object.entries(byProyek).map(([namaProyek, items]) => {
            const totalAng  = items.reduce((s,i)=>s+Number(i.anggaran||0),0);
            const totalReal = items.reduce((s,i)=>s+Number(i.realisasi||0),0);
            const totalVar  = totalAng - totalReal;
            const persen    = totalAng > 0 ? Math.min(100,Math.round(totalReal/totalAng*100)) : 0;
            const over      = totalReal > totalAng;

            return (
              <div key={namaProyek} style={{ background:'white', borderRadius:'12px', overflow:'auto', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
                {/* Header proyek */}
                <div style={{ background: over?'#fdedec':'#f8fbff', padding:'14px 20px', borderBottom:'1px solid #e0e8f4', display:'flex', justifyContent:'space-between', alignItems:'center' }}>
                  <div>
                    <h4 style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c', margin:'0 0 4px' }}>📁 {namaProyek}</h4>
                    <div style={{ display:'flex', gap:'16px', fontSize:'12px' }}>
                      <span>Anggaran: <strong>{formatRp(totalAng)}</strong></span>
                      <span>Realisasi: <strong style={{ color: over?'#e74c3c':'#27ae60' }}>{formatRp(totalReal)}</strong></span>
                      <span>Varian: <strong style={{ color: over?'#e74c3c':'#27ae60' }}>{over?'-':'+' }{formatRp(Math.abs(totalVar))}</strong></span>
                    </div>
                  </div>
                  <div style={{ textAlign:'right' }}>
                    <div style={{ fontSize:'20px', fontWeight:'700', color: over?'#e74c3c':'#1a3a5c' }}>{persen}%</div>
                    <div style={{ fontSize:'11px', color:'#888' }}>Terserap</div>
                  </div>
                </div>

                {/* Progress bar total */}
                <div style={{ padding:'8px 20px', background:'#fafafa', borderBottom:'1px solid #f0f4f8' }}>
                  <div style={{ background:'#eee', borderRadius:'99px', height:'8px', overflow:'auto' }}>
                    <div style={{ width:`${persen}%`, height:'100%', background: over?'#e74c3c': persen>80?'#e67e22':'#27ae60', borderRadius:'99px' }} />
                  </div>
                </div>

                {/* Tabel detail */}
                <table style={{ width:'100%', borderCollapse:'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom:'1px solid #f0f4f8' }}>
                      {['Kategori','Sub Kategori','Anggaran','Realisasi','Varian','%','Periode'].map(h=>(
                        <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'8px 16px', textTransform:'uppercase' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {items.map((a,i)=>{
                      const varian = Number(a.varian||0);
                      const p      = a.anggaran > 0 ? Math.round(a.realisasi/a.anggaran*100) : 0;
                      return (
                        <tr key={i} style={{ borderBottom:'1px solid #f5f7fa' }}>
                          <td style={{ padding:'10px 16px', fontSize:'13px', fontWeight:'500' }}>{a.kategori}</td>
                          <td style={{ padding:'10px 16px', fontSize:'12px', color:'#666' }}>{a.sub_kategori||'-'}</td>
                          <td style={{ padding:'10px 16px', fontSize:'13px', fontWeight:'600' }}>{formatRp(a.anggaran)}</td>
                          <td style={{ padding:'10px 16px', fontSize:'13px', color: Number(a.realisasi)>Number(a.anggaran)?'#e74c3c':'#333' }}>{formatRp(a.realisasi)}</td>
                          <td style={{ padding:'10px 16px', fontSize:'13px', fontWeight:'600', color: varian<0?'#e74c3c':'#27ae60' }}>
                            {varian<0?'-':'+' }{formatRp(Math.abs(varian))}
                          </td>
                          <td style={{ padding:'10px 16px', fontSize:'12px' }}>
                            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                              <div style={{ background:'#f0f4f8', borderRadius:'99px', height:'6px', width:'60px', overflow:'auto' }}>
                                <div style={{ width:`${Math.min(100,p)}%`, height:'100%', background: p>100?'#e74c3c': p>80?'#e67e22':'#27ae60' }} />
                              </div>
                              <span>{p}%</span>
                            </div>
                          </td>
                          <td style={{ padding:'10px 16px', fontSize:'12px', color:'#888' }}>{a.periode||'-'}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            );
          })
      )}

      {/* MODAL FORM ANGGARAN */}
      <Modal show={showForm} onClose={()=>setShowForm(false)} title="📊 Tambah Anggaran Proyek"
        footer={<>
          <Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn>
          <Btn onClick={submitAnggaran} disabled={submitting}>{submitting?'⏳...':'✅ Simpan'}</Btn>
        </>}
      >
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          {[
            { label:'Proyek *',     name:'proyek_id',    type:'select', opts: proyekList },
            { label:'Periode',      name:'periode',      type:'text',   ph:'2025'       },
            { label:'Kategori *',   name:'kategori',     type:'select', opts:[{id:'Material',nama:'Material'},{id:'Tenaga Kerja',nama:'Tenaga Kerja'},{id:'Peralatan',nama:'Peralatan'},{id:'Overhead',nama:'Overhead'},{id:'Lainnya',nama:'Lainnya'}] },
            { label:'Sub Kategori', name:'sub_kategori', type:'text',   ph:'Opsional'   },
            { label:'Jumlah Anggaran (Rp) *', name:'anggaran', type:'number', ph:'0', span:true },
          ].map(f=>(
            <div key={f.name} style={{ display:'flex', flexDirection:'column', gap:'6px', gridColumn: f.span?'1/-1':'auto' }}>
              <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>{f.label}</label>
              {f.type==='select'
                ? <select name={f.name} value={form[f.name]} onChange={handleChange} style={inputStyle}>
                    <option value="">-- Pilih --</option>
                    {f.opts.map(o=><option key={o.id} value={o.id}>{o.nama}</option>)}
                  </select>
                : <input type={f.type||'text'} name={f.name} value={form[f.name]} onChange={handleChange} placeholder={f.ph} style={inputStyle} />
              }
            </div>
          ))}
        </div>
        <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
          <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Catatan</label>
          <textarea name="catatan" value={form.catatan} onChange={handleChange} rows="2" style={{ ...inputStyle, resize:'vertical' }} />
        </div>
      </Modal>
    </div>
  );
}

// ============================================
// TAB: PEMBAYARAN VENDOR
// ============================================
function TabPembayaranVendor({ user }) {
  const [poList, setPoList]         = useState([]);
  const [pbvList, setPbvList]       = useState([]);
  const [kasList, setKasList]       = useState([]);
  const [loading, setLoading]       = useState(true);
  const [showForm, setShowForm]     = useState(false);
  const [poSelected, setPoSelected] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [filterPO, setFilterPO]     = useState('');

  const [form, setForm] = useState({
    kas_bank_id: '', tanggal: tglHariIni(),
    jumlah: '', metode: 'transfer',
    referensi: '', catatan: ''
  });

  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    setLoading(true);
    try {
      const [poRes, pbvRes, kasRes] = await Promise.all([
        keuanganAPI.getPOApproved(),
        keuanganAPI.getAllPembayaranVendor(),
        keuanganAPI.getAllKasBank(),
      ]);
      if (poRes.ok)  setPoList(poRes.data.data);
      if (pbvRes.ok) setPbvList(pbvRes.data.data);
      if (kasRes.ok) setKasList(kasRes.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  function handleChange(e) { setForm({...form, [e.target.name]: e.target.value}); }

  function bukaBayar(po) {
    setPoSelected(po);
    setForm({
      kas_bank_id: '',
      tanggal:     tglHariIni(),
      jumlah:      String(po.sisa_tagihan > 0 ? po.sisa_tagihan : po.total_nilai),
      metode:      'transfer',
      referensi:   po.no_spb,
      catatan:     `Pembayaran SPB ${po.no_spb} - ${po.nama_supplier}`
    });
    setShowForm(true);
  }

  async function submitBayar() {
    if (!form.kas_bank_id || !form.jumlah) {
      alert('⚠️ Rekening dan jumlah wajib diisi!'); return;
    }
    if (Number(form.jumlah) <= 0) {
      alert('⚠️ Jumlah harus lebih dari 0'); return;
    }
    setSubmitting(true);
    try {
      const result = await keuanganAPI.createPembayaranVendor({
        po_id:       poSelected?.id || null,
        kas_bank_id: Number(form.kas_bank_id),
        nama_vendor: poSelected?.nama_supplier || '',
        tanggal:     form.tanggal,
        jumlah:      Number(form.jumlah),
        metode:      form.metode,
        referensi:   form.referensi,
        catatan:     form.catatan,
      });

      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setPoSelected(null);
        fetchData();
      } else {
        alert(`❌ ${result.data.message}`);
      }
    } catch(err) {
      alert('❌ Gagal terhubung ke server');
    } finally {
      setSubmitting(false);
    }
  }

  // Filter PO berdasarkan search
  const poFiltered = filterPO
    ? poList.filter(p =>
        p.no_spb?.toLowerCase().includes(filterPO.toLowerCase()) ||
        p.nama_supplier?.toLowerCase().includes(filterPO.toLowerCase()) ||
        p.nama_proyek?.toLowerCase().includes(filterPO.toLowerCase())
      )
    : poList;

  // Total summary
  const totalNilaiPO   = poList.reduce((s,p) => s + Number(p.total_nilai||0), 0);
  const totalTerbayar  = poList.reduce((s,p) => s + Number(p.total_terbayar||0), 0);
  const totalSisa      = poList.reduce((s,p) => s + Number(p.sisa_tagihan||0), 0);

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

      {/* STAT CARDS */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:'16px' }}>
        {[
          { icon:'🛒', label:'Total Nilai SPB Approved', val: formatRp(totalNilaiPO),  bg:'linear-gradient(135deg,#1a3a5c,#2d6a9f)' },
          { icon:'✅', label:'Total Sudah Dibayar',      val: formatRp(totalTerbayar), bg:'linear-gradient(135deg,#1e8449,#27ae60)'  },
          { icon:'⏳', label:'Total Sisa Hutang',        val: formatRp(totalSisa),     bg:'linear-gradient(135deg,#c0392b,#e74c3c)'  },
        ].map((s,i)=>(
          <div key={i} style={{ background:s.bg, borderRadius:'12px', padding:'20px', color:'white', display:'flex', flexDirection:'column', gap:'6px' }}>
            <span style={{ fontSize:'20px' }}>{s.icon}</span>
            <span style={{ fontSize:'20px', fontWeight:'700' }}>{s.val}</span>
            <span style={{ fontSize:'12px', opacity:0.85 }}>{s.label}</span>
          </div>
        ))}
      </div>

      {/* DAFTAR SPB APPROVED */}
      <div style={{ background:'white', borderRadius:'12px', padding:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'16px' }}>
          <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c', margin:0 }}>
            🛒 SPB Disetujui — Menunggu Pembayaran
          </h3>
          <input
            value={filterPO}
            onChange={e=>setFilterPO(e.target.value)}
            placeholder="🔍 Cari SPB, vendor, proyek..."
            style={{ ...inputStyle, maxWidth:'240px', padding:'8px 12px' }}
          />
        </div>

        {loading ? <LoadingSpinner pesan="Memuat data SPB..." /> : (
          poFiltered.length === 0
            ? <EmptyState icon="🛒" judul="Belum ada SPB disetujui" sub="SPB yang sudah disetujui Direktur akan muncul di sini" />
            : (
              <div style={{ overflowX:'auto' }}>
                <table style={{ width:'100%', borderCollapse:'collapse' }}>
                  <thead>
                    <tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                      {['No. SPB','Tgl','Supplier / Vendor','Proyek','Nilai PO','Terbayar','Sisa Tagihan','Status Bayar','Aksi'].map(h=>(
                        <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'8px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {poFiltered.map(po=>{
                      const sisa        = Number(po.sisa_tagihan||0);
                      const terbayar    = Number(po.total_terbayar||0);
                      const nilai       = Number(po.total_nilai||0);
                      const statusBayar = sisa <= 0 ? 'lunas' : terbayar > 0 ? 'sebagian' : 'belum';
                      const persen      = nilai > 0 ? Math.min(100, Math.round(terbayar/nilai*100)) : 0;

                      return (
                        <tr key={po.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                          <td style={{ padding:'12px', fontSize:'13px' }}><strong>{po.no_spb}</strong></td>
                          <td style={{ padding:'12px', fontSize:'12px' }}>{po.created_at?.split('T')[0]}</td>
                          <td style={{ padding:'12px' }}>
                            <div style={{ fontSize:'13px', fontWeight:'500' }}>{po.nama_supplier}</div>
                            {po.up_nama && <div style={{ fontSize:'11px', color:'#888' }}>U.P: {po.up_nama}</div>}
                          </td>
                          <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{po.nama_proyek}</td>
                          <td style={{ padding:'12px', fontSize:'13px', fontWeight:'600' }}>{formatRp(nilai)}</td>
                          <td style={{ padding:'12px', fontSize:'13px', color:'#27ae60', fontWeight:'600' }}>
                            {formatRp(terbayar)}
                            {terbayar > 0 && (
                              <div style={{ marginTop:'4px' }}>
                                <div style={{ background:'#f0f4f8', borderRadius:'99px', height:'4px', overflow:'auto', width:'80px' }}>
                                  <div style={{ width:`${persen}%`, height:'100%', background:'#27ae60', borderRadius:'99px' }} />
                                </div>
                                <span style={{ fontSize:'10px', color:'#888' }}>{persen}%</span>
                              </div>
                            )}
                          </td>
                          <td style={{ padding:'12px', fontSize:'13px', fontWeight:'700', color: sisa>0?'#e74c3c':'#27ae60' }}>
                            {sisa > 0 ? formatRp(sisa) : '✅ Lunas'}
                          </td>
                          <td style={{ padding:'12px' }}>
                            <span style={{
                              display:'inline-block', padding:'3px 10px', borderRadius:'99px',
                              fontSize:'11px', fontWeight:'700',
                              background: statusBayar==='lunas'?'#eafaf1': statusBayar==='sebagian'?'#fef5e7':'#fdedec',
                              color:      statusBayar==='lunas'?'#27ae60': statusBayar==='sebagian'?'#e67e22':'#e74c3c',
                            }}>
                              {statusBayar==='lunas'?'✅ Lunas': statusBayar==='sebagian'?'⚡ Sebagian':'❌ Belum Bayar'}
                            </span>
                          </td>
                          <td style={{ padding:'12px' }}>
                            {sisa > 0 && (
                              <button
                                onClick={() => bukaBayar(po)}
                                style={{ padding:'6px 14px', background:'linear-gradient(135deg,#1e8449,#27ae60)', color:'white', border:'none', borderRadius:'8px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}
                              >
                                💳 Bayar
                              </button>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            )
        )}
      </div>

      {/* RIWAYAT PEMBAYARAN */}
      <div style={{ background:'white', borderRadius:'12px', padding:'20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
        <h3 style={{ fontSize:'14px', fontWeight:'700', color:'#1a3a5c', marginBottom:'16px', marginTop:0 }}>
          📜 Riwayat Pembayaran Vendor
        </h3>
        {pbvList.length === 0 ? (
          <EmptyState icon="📜" judul="Belum ada riwayat" sub="Pembayaran yang sudah dilakukan akan muncul di sini" />
        ) : (
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead>
                <tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                  {['No. Pembayaran','Tanggal','No. SPB','Vendor','Rekening','Jumlah','Metode','Referensi','Dibuat'].map(h=>(
                    <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'8px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {pbvList.map(p=>(
                  <tr key={p.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                    <td style={{ padding:'12px', fontSize:'13px' }}><strong style={{ color:'#27ae60' }}>{p.no_pembayaran}</strong></td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{p.tanggal?.split('T')[0]}</td>
                    <td style={{ padding:'12px', fontSize:'12px', color:'#2d6a9f', fontWeight:'600' }}>{p.no_spb||'-'}</td>
                    <td style={{ padding:'12px', fontSize:'12px', fontWeight:'500' }}>{p.nama_vendor}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{p.nama_kas}</td>
                    <td style={{ padding:'12px', fontSize:'13px', fontWeight:'700', color:'#e74c3c' }}>- {formatRp(p.jumlah)}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>
                      <span style={{ display:'inline-block', padding:'2px 8px', background:'#eaf0fb', color:'#2d6a9f', borderRadius:'6px', fontSize:'11px', fontWeight:'600' }}>
                        {p.metode==='transfer'?'🏦 Transfer': p.metode==='tunai'?'💵 Tunai':'📝 Cek/Giro'}
                      </span>
                    </td>
                    <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{p.referensi||'-'}</td>
                    <td style={{ padding:'12px', fontSize:'12px', color:'#888' }}>{p.nama_pembuat}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* MODAL FORM BAYAR */}
      <Modal
        show={showForm}
        onClose={()=>{ setShowForm(false); setPoSelected(null); }}
        title={`💳 Bayar ke Vendor — ${poSelected?.no_spb}`}
        footer={<>
          <Btn color="abu" onClick={()=>{ setShowForm(false); setPoSelected(null); }} disabled={submitting}>Batal</Btn>
          <Btn color="hijau" onClick={submitBayar} disabled={submitting}>
            {submitting ? '⏳ Memproses...' : '✅ Konfirmasi Pembayaran'}
          </Btn>
        </>}
      >
        {poSelected && (
          <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

            {/* INFO SPB */}
            <div style={{ background:'#f8fbff', borderRadius:'12px', padding:'16px', border:'1px solid #e0e8f4' }}>
              <h4 style={{ fontSize:'13px', fontWeight:'700', color:'#1a3a5c', margin:'0 0 12px' }}>📋 Informasi SPB</h4>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'10px' }}>
                {[
                  ['No. SPB',     poSelected.no_spb],
                  ['Proyek',      poSelected.nama_proyek],
                  ['Vendor',      poSelected.nama_supplier],
                  ['Cara Bayar',  poSelected.cara_bayar==='tunai'?'💵 Tunai':'💳 Kredit'],
                  ['Nilai PO',    formatRp(poSelected.total_nilai)],
                  ['Sudah Bayar', formatRp(poSelected.total_terbayar)],
                ].map(([l,v])=>(
                  <div key={l}>
                    <p style={{ fontSize:'11px', color:'#888', fontWeight:'700', margin:'0 0 2px' }}>{l}</p>
                    <p style={{ fontSize:'13px', margin:0, fontWeight: l==='Nilai PO'||l==='Sudah Bayar'?'700':'400' }}>{v}</p>
                  </div>
                ))}
              </div>

              {/* Progress pembayaran */}
              <div style={{ marginTop:'12px' }}>
                <div style={{ display:'flex', justifyContent:'space-between', marginBottom:'4px' }}>
                  <span style={{ fontSize:'12px', color:'#666' }}>Progress Pembayaran</span>
                  <span style={{ fontSize:'12px', fontWeight:'700', color:'#e74c3c' }}>
                    Sisa: {formatRp(poSelected.sisa_tagihan)}
                  </span>
                </div>
                <div style={{ background:'#f0f4f8', borderRadius:'99px', height:'10px', overflow:'auto' }}>
                  <div style={{
                    width: `${poSelected.total_nilai > 0 ? Math.min(100, Math.round(poSelected.total_terbayar/poSelected.total_nilai*100)) : 0}%`,
                    height:'100%', background:'#27ae60', borderRadius:'99px'
                  }} />
                </div>
              </div>
            </div>

            {/* FORM PEMBAYARAN */}
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Bayar dari Rekening <span style={{ color:'#e74c3c' }}>*</span></label>
                <select name="kas_bank_id" value={form.kas_bank_id} onChange={handleChange} style={inputStyle}>
                  <option value="">-- Pilih Rekening --</option>
                  {kasList.map(k=>(
                    <option key={k.id} value={k.id}>
                      {k.nama} — Saldo: {formatRp(k.saldo)}
                    </option>
                  ))}
                </select>
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Tanggal Bayar <span style={{ color:'#e74c3c' }}>*</span></label>
                <input type="date" name="tanggal" value={form.tanggal} onChange={handleChange} style={inputStyle} />
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Jumlah Dibayar (Rp) <span style={{ color:'#e74c3c' }}>*</span></label>
                <input type="number" name="jumlah" value={form.jumlah} onChange={handleChange} placeholder="0" style={{ ...inputStyle, fontWeight:'700', color:'#e74c3c' }} />
                <span style={{ fontSize:'11px', color:'#888' }}>
                  Sisa tagihan: <strong style={{ color:'#e74c3c' }}>{formatRp(poSelected.sisa_tagihan)}</strong>
                </span>
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:'6px' }}>
                <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Metode Pembayaran</label>
                <select name="metode" value={form.metode} onChange={handleChange} style={inputStyle}>
                  <option value="transfer">🏦 Transfer Bank</option>
                  <option value="tunai">💵 Tunai</option>
                  <option value="cek">📝 Cek / Giro</option>
                </select>
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:'6px', gridColumn:'1/-1' }}>
                <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>No. Referensi / Bukti Transfer</label>
                <input name="referensi" value={form.referensi} onChange={handleChange} placeholder="No. transfer, bukti pembayaran" style={inputStyle} />
              </div>
              <div style={{ display:'flex', flexDirection:'column', gap:'6px', gridColumn:'1/-1' }}>
                <label style={{ fontSize:'12px', fontWeight:'700', color:'#555' }}>Catatan</label>
                <textarea name="catatan" value={form.catatan} onChange={handleChange} rows="2"
                  style={{ ...inputStyle, resize:'vertical' }} />
              </div>
            </div>

            {/* PREVIEW TOTAL */}
            {form.jumlah && Number(form.jumlah) > 0 && (
              <div style={{
                padding:'14px', borderRadius:'10px', border:'2px solid #27ae60',
                background:'#eafaf1', display:'flex', justifyContent:'space-between', alignItems:'center'
              }}>
                <span style={{ fontSize:'13px', color:'#1e8449', fontWeight:'600' }}>
                  💳 Total yang akan dibayarkan:
                </span>
                <span style={{ fontSize:'18px', fontWeight:'700', color:'#1e8449' }}>
                  {formatRp(form.jumlah)}
                </span>
              </div>
            )}

          </div>
        )}
      </Modal>
    </div>
  );
}


const kategoriPengeluaran = [
  { val:'bahan',     label:'🧱 Bahan / Material' },
  { val:'lain',      label:'📦 Lain-lain'        },
  { val:'bbm',       label:'⛽ BBM'              },
  { val:'etoll',     label:'🛣️ E-Toll'           },
  { val:'peralatan', label:'🔧 Peralatan'        },
  { val:'upah',      label:'👷 Upah'             },
];

function badgeStatusKas(status) {
  const map = {
    diajukan:  { bg:'#fef5e7', color:'#e67e22', label:'⏳ Diajukan'  },
    disetujui: { bg:'#eafaf1', color:'#27ae60', label:'✅ Disetujui' },
    dicairkan: { bg:'#eaf0fb', color:'#2980b9', label:'💵 Dicairkan' },
    ditolak:   { bg:'#fdedec', color:'#e74c3c', label:'❌ Ditolak'   },
  };
  const s = map[status] || { bg:'#f0f4f8', color:'#666', label:status };
  return <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background:s.bg, color:s.color }}>{s.label}</span>;
}

// ============================================
// TAB: PENGAJUAN KAS
// ============================================
function TabPengajuanKas({ user }) {
  const detailRef                 = useRef(null);
  const [list, setList]           = useState([]);
  const [kasList, setKasList]     = useState([]);
  const [loading, setLoading]     = useState(true);
  const [showForm, setShowForm]   = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [showCairkan, setShowCairkan] = useState(null);
  const [filterStatus, setFilterStatus] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const proyekList = useProyekList();

  const itemKosong = { uraian:'', volume:'', satuan:'', harga_satuan:'', keterangan:'' };
  const [form, setForm] = useState({ proyek_id:'', tanggal: tglHariIni(), catatan:'', items:[{...itemKosong}] });
  const [formCairkan, setFormCairkan] = useState({ kas_bank_id:'', tanggal: tglHariIni() });

  useEffect(() => { fetchData(); }, [filterStatus]);

  async function fetchData() {
    setLoading(true);
    try {
      const [pRes, kRes] = await Promise.all([
        keuanganAPI.getAllPengajuanKas(filterStatus?{status:filterStatus}:{}),
        keuanganAPI.getAllKasBank(),
      ]);
      if (pRes.ok) setList(pRes.data.data);
      if (kRes.ok) setKasList(kRes.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  function handleChange(e) { setForm({...form,[e.target.name]:e.target.value}); }
  function updateItem(idx,field,value) { setForm({...form, items: form.items.map((it,i)=>i===idx?{...it,[field]:value}:it)}); }
  function tambahItem() { setForm({...form, items:[...form.items,{...itemKosong}]}); }
  function hapusItem(idx) { setForm({...form, items: form.items.filter((_,i)=>i!==idx)}); }

  const totalForm = form.items.reduce((s,i)=>s+Number(i.volume||0)*Number(i.harga_satuan||0),0);

  async function submitPengajuan() {
    if (!form.tanggal || !form.items[0].uraian) { alert('⚠️ Tanggal dan minimal 1 item wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = await keuanganAPI.createPengajuanKas({ ...form, proyek_id: form.proyek_id?Number(form.proyek_id):null, items: form.items.filter(i=>i.uraian) });
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setForm({ proyek_id:'', tanggal:tglHariIni(), catatan:'', items:[{...itemKosong}] });
        fetchData();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  async function prosesApproval(id, aksi) {
    if (!window.confirm(`${aksi==='approve'?'✅ Setujui':'❌ Tolak'} pengajuan ini?`)) return;
    const result = await keuanganAPI.approvePengajuanKas(id, aksi);
    if (result.ok) { alert(`✅ ${result.data.message}`); setShowDetail(null); fetchData(); }
    else alert(`❌ ${result.data.message}`);
  }

  async function submitCairkan() {
    if (!formCairkan.kas_bank_id) { alert('⚠️ Pilih rekening pencairan!'); return; }
    setSubmitting(true);
    try {
      const result = await keuanganAPI.cairkanPengajuanKas(showCairkan.id, { ...formCairkan, kas_bank_id: Number(formCairkan.kas_bank_id) });
      if (result.ok) { alert(`✅ ${result.data.message}`); setShowCairkan(null); fetchData(); }
      else alert(`❌ ${result.data.message}`);
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  const thS = { padding:'8px 10px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center', background:'#f0f4f8' };
  const tdS = { border:'1px solid #ddd', padding:'6px 8px', fontSize:'12px' };
  const inC = { ...inputStyle, padding:'5px 7px', fontSize:'12px', border:'none', background:'transparent', width:'100%' };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
        <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)} style={{ ...inputStyle, maxWidth:'180px' }}>
          <option value="">Semua Status</option>
          <option value="diajukan">Diajukan</option>
          <option value="disetujui">Disetujui</option>
          <option value="dicairkan">Dicairkan</option>
          <option value="ditolak">Ditolak</option>
        </select>
        <Btn onClick={()=>setShowForm(true)}>+ Ajukan Kas Baru</Btn>
      </div>

      {loading ? <LoadingSpinner pesan="Memuat data..." /> : (
        list.length===0 ? <EmptyState icon="📝" judul="Belum ada pengajuan" sub="Klik '+ Ajukan Kas Baru' untuk membuat pengajuan" /> : (
          <div style={{ background:'white', borderRadius:'12px', overflow:'auto', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                {['No. Pengajuan','Tanggal','Proyek','Jumlah','Status','Diajukan','Aksi'].map(h=>(
                  <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'10px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {list.map(p=>(
                  <tr key={p.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                    <td style={{ padding:'12px', fontSize:'13px' }}><strong>{p.no_pengajuan}</strong></td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{p.tanggal?.split('T')[0]}</td>
                    <td style={{ padding:'12px', fontSize:'12px' }}>{p.nama_proyek||'-'}</td>
                    <td style={{ padding:'12px', fontSize:'13px', fontWeight:'600' }}>{formatRp(p.jumlah_total)}</td>
                    <td style={{ padding:'12px' }}>{badgeStatusKas(p.status)}</td>
                    <td style={{ padding:'12px', fontSize:'12px', color:'#666' }}>{p.nama_pengaju}</td>
                    <td style={{ padding:'12px' }}>
                      <div style={{ display:'flex', gap:'6px', flexWrap:'wrap' }}>
                        <button onClick={()=>setShowDetail(p)} style={{ padding:'5px 12px', background:'#eaf0fb', color:'#2d6a9f', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>
                          Detail
                        </button>
                        {p.status==='diajukan' && user?.divisi==='direktur' && <>
                          <Btn size="small" color="merah" onClick={()=>prosesApproval(p.id,'reject')}>Tolak</Btn>
                          <Btn size="small" color="hijau" onClick={()=>prosesApproval(p.id,'approve')}>Setujui</Btn>
                        </>}
                        {p.status==='disetujui' && <Btn size="small" onClick={()=>{ setShowCairkan(p); setFormCairkan({ kas_bank_id:'', tanggal:tglHariIni() }); }}>💵 Cairkan</Btn>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}

      {/* MODAL FORM PENGAJUAN — replika F-001 */}
      <Modal show={showForm} onClose={()=>setShowForm(false)} title="📝 Pengajuan Penggunaan Kas"
        footer={<><Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn><Btn onClick={submitPengajuan} disabled={submitting}>{submitting?'⏳...':'📤 Ajukan'}</Btn></>}>
        <div style={{ border:'2px solid #1a3a5c', borderRadius:'8px', overflow:'auto', fontSize:'12px' }}>
          {/* KOP */}
          <KopFormulir
            judulFormulir="Pengajuan Penggunaan Kas"
            rows={[
              ['No. Dok', 'MKMJ/FM/KEU/01-01'],
              ['Revisi', '01'],
              ['Tgl. Terbit', '01 Juni 2026'],
            ]}
          />
          <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontWeight:'600', color:'#444', minWidth:'80px' }}>PROYEK</span><span>:</span>
              <div style={{ flex:1 }}>
                <SelectProyekK
                  value={form.proyek_id}
                  onChange={(val)=>setForm(prev=>({ ...prev, proyek_id: val }))}
                  list={proyekList}
                />
              </div>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontWeight:'600', color:'#444', minWidth:'80px' }}>Tanggal</span><span>:</span>
              <input type="date" name="tanggal" value={form.tanggal} onChange={handleChange} style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
            </div>
          </div>
          <div style={{ overflowX:'auto', overflowY:'auto', maxHeight:'240px' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', minWidth:'560px' }}>
              <thead style={{ position:'sticky', top:0 }}>
                <tr>{['No.','Uraian','Volume','Satuan','Harga Satuan','Total','Ket',''].map(h=><th key={h} style={thS}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {form.items.map((it,idx)=>{
                  const tot = Number(it.volume||0)*Number(it.harga_satuan||0);
                  return (
                    <tr key={idx}>
                      <td style={{ ...tdS, textAlign:'center', fontWeight:'700', width:'30px' }}>{idx+1}</td>
                      <td style={{ ...tdS, padding:'3px' }}><input value={it.uraian} onChange={e=>updateItem(idx,'uraian',e.target.value)} placeholder="Uraian pengeluaran" style={inC} /></td>
                      <td style={{ ...tdS, padding:'3px', width:'70px' }}><input type="number" value={it.volume} onChange={e=>updateItem(idx,'volume',e.target.value)} placeholder="0" style={{ ...inC, textAlign:'center' }} /></td>
                      <td style={{ ...tdS, padding:'3px', width:'70px' }}><input value={it.satuan} onChange={e=>updateItem(idx,'satuan',e.target.value)} placeholder="ls" style={{ ...inC, textAlign:'center' }} /></td>
                      <td style={{ ...tdS, padding:'3px', width:'120px' }}><input type="number" value={it.harga_satuan} onChange={e=>updateItem(idx,'harga_satuan',e.target.value)} placeholder="0" style={{ ...inC, textAlign:'right' }} /></td>
                      <td style={{ ...tdS, textAlign:'right', fontWeight:'600', width:'120px', background:'#f8fbff' }}>{formatRp(tot)}</td>
                      <td style={{ ...tdS, padding:'3px' }}><input value={it.keterangan} onChange={e=>updateItem(idx,'keterangan',e.target.value)} style={inC} /></td>
                      <td style={{ ...tdS, width:'30px', textAlign:'center' }}>{form.items.length>1 && <button onClick={()=>hapusItem(idx)} style={{ background:'none', border:'none', cursor:'pointer', opacity:0.4 }}>🗑️</button>}</td>
                    </tr>
                  );
                })}
                <tr style={{ background:'#f0f4f8' }}>
                  <td colSpan={5} style={{ ...tdS, textAlign:'center', fontWeight:'700' }}>JUMLAH TOTAL</td>
                  <td style={{ ...tdS, textAlign:'right', fontWeight:'700', color:'#1a3a5c' }}>{formatRp(totalForm)}</td>
                  <td style={tdS}></td><td style={tdS}></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div style={{ padding:'8px 12px', borderTop:'1px solid #ddd', borderBottom:'1px solid #ddd', background:'#fafcff' }}>
            <button onClick={tambahItem} style={{ padding:'5px 14px', background:'white', border:'1.5px dashed #2d6a9f', borderRadius:'6px', fontSize:'12px', color:'#2d6a9f', cursor:'pointer', fontWeight:'600' }}>+ Tambah Baris</button>
          </div>
          <div style={{ padding:'10px 16px', borderBottom:'1px solid #ddd' }}>
            <label style={{ fontSize:'12px', fontWeight:'600', color:'#444', display:'block', marginBottom:'6px' }}>Keterangan</label>
            <textarea name="catatan" value={form.catatan} onChange={handleChange} rows="2" style={{ ...inputStyle, resize:'vertical', fontSize:'12px' }} />
          </div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr' }}>
            {[['Disetujui oleh,','................................','Direktur'],['Diperiksa oleh,','................................','Manajer Proyek'],['Dibuat oleh,',user?.nama||'................................',user?.role||'']].map(([j,n,r],i)=>(
              <div key={i} style={{ padding:'12px 16px', borderRight: i<2?'1px solid #ddd':'none' }}>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'44px' }}>{j}</div>
                <div style={{ borderTop:'1px solid #333', paddingTop:'4px' }}>
                  <div style={{ fontSize:'11px', color:'#555' }}>( {n} )</div>
                  <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{r}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Modal>

      {/* MODAL DETAIL */}
        <Modal show={!!showDetail} onClose={()=>setShowDetail(null)} title={`Detail — ${showDetail?.no_pengajuan}`}
          footer={<>
            <BtnExportPDF targetRef={detailRef} filename={`Pengajuan-Kas-${showDetail?.no_pengajuan}`} />
            <Btn color="abu" onClick={()=>setShowDetail(null)}>Tutup</Btn>
            {showDetail?.status==='diajukan' && user?.divisi==='direktur' && <>
              <Btn color="merah" onClick={()=>prosesApproval(showDetail.id,'reject')}>❌ Tolak</Btn>
              <Btn color="hijau" onClick={()=>prosesApproval(showDetail.id,'approve')}>✅ Setujui</Btn>
            </>}
          </>}>
          {showDetail && (
            <div ref={detailRef} style={{ border:'2px solid #1a3a5c', borderRadius:'8px', overflow:'auto', fontSize:'12px' }}>

            {/* KOP */}
            <KopFormulir
              judulFormulir="Pengajuan Penggunaan Kas"
              rows={[
                ['No. Dok', 'MKMJ/FM/KEU/01-01'],
                ['Revisi', '01'],
                ['Tgl. Terbit', '01 Juni 2026'],
              ]}
            />

            {/* INFO HEADER */}
            <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
              {[
                ['No. Pengajuan', showDetail.no_pengajuan],
                ['Proyek',        showDetail.nama_proyek||'-'],
                ['Tanggal',       showDetail.tanggal?.split('T')[0]],
                ['Status',        showDetail.status],
              ].map(([l,v])=>(
                <div key={l} style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                  <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>{l}</span>
                  <span>:</span>
                  <span style={{ flex:1 }}>{l==='Status' ? badgeStatusKas(v) : (v||'-')}</span>
                </div>
              ))}
            </div>

            {/* TABEL ITEM */}
            <div style={{ overflowX:'auto' }}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead><tr>{['No.','Uraian','Vol','Sat','Harga','Total'].map(h=><th key={h} style={thS}>{h}</th>)}</tr></thead>
                <tbody>
                  {(showDetail.items||[]).map((it,i)=>(
                    <tr key={i}>
                      <td style={{ ...tdS, textAlign:'center' }}>{i+1}</td>
                      <td style={tdS}>{it.uraian}</td>
                      <td style={{ ...tdS, textAlign:'center' }}>{it.volume}</td>
                      <td style={{ ...tdS, textAlign:'center' }}>{it.satuan}</td>
                      <td style={{ ...tdS, textAlign:'right' }}>{formatRp(it.harga_satuan)}</td>
                      <td style={{ ...tdS, textAlign:'right', fontWeight:'600' }}>{formatRp(it.total)}</td>
                    </tr>
                  ))}
                  <tr style={{ background:'#f0f4f8' }}>
                    <td colSpan={5} style={{ ...tdS, textAlign:'center', fontWeight:'700' }}>JUMLAH TOTAL</td>
                    <td style={{ ...tdS, textAlign:'right', fontWeight:'700', color:'#1a3a5c' }}>{formatRp(showDetail.jumlah_total)}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* KETERANGAN */}
            {showDetail.catatan && (
              <div style={{ padding:'10px 16px', borderTop:'1px solid #ddd', fontSize:'12px', color:'#555' }}>
                <strong>Keterangan:</strong> {showDetail.catatan}
              </div>
            )}

            {/* TANDA TANGAN */}
            <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', borderTop:'1px solid #ddd' }}>
              {[
                { judul:'Disetujui oleh,', nama: showDetail.status==='disetujui'||showDetail.status==='dicairkan' ? (showDetail.nama_penyetuju||'................................') : '................................', jab:'Direktur' },
                { judul:'Diperiksa oleh,', nama: '................................', jab:'Keuangan' },
                { judul:'Diajukan oleh,',  nama: showDetail.nama_pengaju||'................................', jab:'Pengaju' },
              ].map((t,i)=>(
                <div key={i} style={{ padding:'12px 16px', borderRight: i<2?'1px solid #ddd':'none' }}>
                  <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'44px' }}>{t.judul}</div>
                  <div style={{ borderTop:'1px solid #333', paddingTop:'4px' }}>
                    <div style={{ fontSize:'11px', color:'#555' }}>( {t.nama} )</div>
                    <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{t.jab}</div>
                  </div>
                </div>
              ))}
            </div>

          </div>
        )}
      </Modal>

      {/* MODAL CAIRKAN */}
      <Modal show={!!showCairkan} onClose={()=>setShowCairkan(null)} title={`💵 Cairkan Kasbon — ${showCairkan?.no_pengajuan}`} size="420px"
        footer={<><Btn color="abu" onClick={()=>setShowCairkan(null)} disabled={submitting}>Batal</Btn><Btn color="hijau" onClick={submitCairkan} disabled={submitting}>{submitting?'⏳...':'✅ Cairkan'}</Btn></>}>
        {showCairkan && (
          <div style={{ display:'flex', flexDirection:'column', gap:'12px' }}>
            <div style={{ background:'#f8fbff', padding:'12px', borderRadius:'8px', fontSize:'13px' }}>Jumlah dicairkan: <strong>{formatRp(showCairkan.jumlah_total)}</strong></div>
            <FG label="Rekening Sumber" required>
              <select value={formCairkan.kas_bank_id} onChange={e=>setFormCairkan({...formCairkan,kas_bank_id:e.target.value})} style={inputStyle}>
                <option value="">-- Pilih --</option>
                {kasList.map(k=><option key={k.id} value={k.id}>{k.nama} — {formatRp(k.saldo)}</option>)}
              </select>
            </FG>
            <FG label="Tanggal Pencairan">
              <input type="date" value={formCairkan.tanggal} onChange={e=>setFormCairkan({...formCairkan,tanggal:e.target.value})} style={inputStyle} />
            </FG>
          </div>
        )}
      </Modal>
    </div>
  );
}




// ============================================
// TAB: LAPORAN PENGGUNAAN KAS
// ============================================
function TabLaporanKas({ user }) {
  const [list, setList]             = useState([]);
  const [siapLaporan, setSiapLaporan] = useState([]);
  const [kasList, setKasList]       = useState([]);
  const [loading, setLoading]       = useState(true);
  const [showForm, setShowForm]     = useState(false);
  const [showDetail, setShowDetail] = useState(null);
  const [showApprove, setShowApprove] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [kasBankApprove, setKasBankApprove] = useState('');
  const proyekList = useProyekList();

  const itemKosong = { tanggal: tglHariIni(), nama_proyek_text:'', uraian:'', kategori:'lain', jumlah:'' };
  const [form, setForm] = useState({ pengajuan_id:'', proyek_id:'', nama_pemegang:'', periode_dari:'', periode_sampai:'', kasbon:'', items:[{...itemKosong}], fotoDokumen:[] });

  const [uploading, setUploading] = useState(false);
  

async function handleUploadFoto(e) {
  const files = Array.from(e.target.files);
  if (files.length === 0) return;

  setUploading(true);
  try {
    const result = await uploadAPI.uploadLaporanKas(files);
    if (result.ok) {
      setForm(prev => ({ ...prev, fotoDokumen: [...prev.fotoDokumen, ...result.data.files] }));
    } else {
      alert(`❌ ${result.data.message}`);
    }
  } catch (err) {
    alert('❌ Gagal upload file. Pastikan backend berjalan.');
  } finally {
    setUploading(false);
    e.target.value = ''; // reset input agar bisa upload file sama lagi kalau perlu
  }}

function hapusFotoLaporan(idx) {
  setForm({ ...form, fotoDokumen: form.fotoDokumen.filter((_,i)=>i!==idx) });
}
  useEffect(() => { fetchData(); }, []);

  async function fetchData() {
    setLoading(true);
    try {
      const [lRes, sRes, kRes] = await Promise.all([
        keuanganAPI.getAllLaporanKas(),
        keuanganAPI.getPengajuanSiapLaporan(),
        keuanganAPI.getAllKasBank(),
      ]);
      if (lRes.ok) setList(lRes.data.data);
      if (sRes.ok) setSiapLaporan(sRes.data.data);
      if (kRes.ok) setKasList(kRes.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  function handleChange(e) { setForm({...form,[e.target.name]:e.target.value}); }
  function updateItem(idx,field,value) { setForm({...form, items: form.items.map((it,i)=>i===idx?{...it,[field]:value}:it)}); }
  function tambahItem() { setForm({...form, items:[...form.items,{...itemKosong}]}); }
  function hapusItem(idx) { setForm({...form, items: form.items.filter((_,i)=>i!==idx)}); }

  function pilihPengajuan(id) {
    const p = siapLaporan.find(x=>String(x.id)===id);
    setForm({ ...form, pengajuan_id: id, proyek_id: p?.proyek_id||'', kasbon: p ? String(p.jumlah_total) : form.kasbon });
  }

  const totalPengeluaranForm = form.items.reduce((s,i)=>s+Number(i.jumlah||0),0);
  const sisaKurangForm = Number(form.kasbon||0) - totalPengeluaranForm;

  async function submitLaporan() {
    if (!form.nama_pemegang || !form.items[0].uraian) { alert('⚠️ Nama pemegang kas dan minimal 1 item wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = await keuanganAPI.createLaporanKas({
        ...form,
        pengajuan_id: form.pengajuan_id?Number(form.pengajuan_id):null,
        proyek_id:    form.proyek_id?Number(form.proyek_id):null,
        kasbon:       Number(form.kasbon||0),
        items:        form.items.filter(i=>i.uraian),
        lampiran:     form.fotoDokumen,
      });
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setForm({ pengajuan_id:'', proyek_id:'', nama_pemegang:'', periode_dari:'', periode_sampai:'', kasbon:'', items:[{...itemKosong}], fotoDokumen:[] });
        fetchData();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  async function submitApprove() {
    setSubmitting(true);
    try {
      const result = await keuanganAPI.approveLaporanKas(showApprove.id, kasBankApprove?Number(kasBankApprove):null);
      if (result.ok) { alert(`✅ ${result.data.message}`); setShowApprove(null); fetchData(); }
      else alert(`❌ ${result.data.message}`);
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  const thS = { padding:'8px 10px', fontSize:'11px', fontWeight:'700', color:'#444', border:'1px solid #ddd', textAlign:'center', background:'#f0f4f8' };
  const tdS = { border:'1px solid #ddd', padding:'6px 8px', fontSize:'12px' };
  const inC = { ...inputStyle, padding:'5px 7px', fontSize:'12px', border:'none', background:'transparent', width:'100%' };
  const kategoriLabel = (k) => kategoriPengeluaran.find(x=>x.val===k)?.label || k;

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>
      <div style={{ display:'flex', justifyContent:'flex-end' }}>
        <Btn onClick={()=>setShowForm(true)}>+ Buat Laporan Penggunaan Kas</Btn>
      </div>

      {loading ? <LoadingSpinner pesan="Memuat laporan..." /> : (
        list.length===0 ? <EmptyState icon="📄" judul="Belum ada laporan" sub="Klik '+ Buat Laporan' untuk mempertanggungjawabkan kasbon" /> : (
          <div style={{ background:'white', borderRadius:'12px', overflow:'auto', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <table style={{ width:'100%', borderCollapse:'collapse' }}>
              <thead><tr style={{ borderBottom:'2px solid #f0f4f8' }}>
                {['No. Laporan','Ref. Kasbon','Pemegang Kas','Proyek','Kasbon','Pengeluaran','Sisa/Kurang','Status','Aksi'].map(h=>(
                  <th key={h} style={{ textAlign:'left', fontSize:'11px', fontWeight:'700', color:'#888', padding:'10px 12px', textTransform:'uppercase', whiteSpace:'nowrap' }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {list.map(l=>{
                  const sisa = Number(l.sisa_kurang);
                  return (
                    <tr key={l.id} style={{ borderBottom:'1px solid #f5f7fa' }}>
                      <td style={{ padding:'12px', fontSize:'13px' }}><strong>{l.no_laporan}</strong></td>
                      <td style={{ padding:'12px', fontSize:'12px', color:'#888' }}>{l.no_pengajuan||'-'}</td>
                      <td style={{ padding:'12px', fontSize:'12px', fontWeight:'500' }}>{l.nama_pemegang}</td>
                      <td style={{ padding:'12px', fontSize:'12px' }}>{l.nama_proyek||'-'}</td>
                      <td style={{ padding:'12px', fontSize:'13px' }}>{formatRp(l.kasbon)}</td>
                      <td style={{ padding:'12px', fontSize:'13px', color:'#e74c3c' }}>{formatRp(l.jumlah_pengeluaran)}</td>
                      <td style={{ padding:'12px', fontSize:'13px', fontWeight:'700', color: sisa>=0?'#27ae60':'#e74c3c' }}>
                        {sisa>=0 ? `Sisa ${formatRp(sisa)}` : `Kurang ${formatRp(Math.abs(sisa))}`}
                      </td>
                      <td style={{ padding:'12px' }}>
                        <span style={{ padding:'3px 10px', borderRadius:'99px', fontSize:'11px', fontWeight:'700', background: l.status==='disetujui'?'#eafaf1':'#fef5e7', color: l.status==='disetujui'?'#27ae60':'#e67e22' }}>
                          {l.status==='disetujui'?'✅ Disetujui & Settle':'⏳ Diajukan'}
                        </span>
                      </td>
                      <td style={{ padding:'12px' }}>
                        <div style={{ display:'flex', gap:'6px', flexWrap:'wrap' }}>
                          <button onClick={()=>setShowDetail(l)} style={{ padding:'5px 12px', background:'#eaf0fb', color:'#2d6a9f', border:'none', borderRadius:'6px', fontSize:'12px', fontWeight:'600', cursor:'pointer' }}>
                            Detail
                          </button>
                          {l.status==='diajukan' && user?.divisi==='direktur' && (
                            <Btn size="small" color="hijau" onClick={()=>{ setShowApprove(l); setKasBankApprove(''); }}>✅ Setujui & Settle</Btn>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )
      )}

      {/* MODAL FORM LAPORAN — replika F-002 */}
      <Modal show={showForm} onClose={()=>setShowForm(false)} title="📄 Laporan Pertanggungjawaban Penggunaan Kas" size="720px"
        footer={<><Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn><Btn onClick={submitLaporan} disabled={submitting}>{submitting?'⏳...':'📤 Kirim Laporan'}</Btn></>}>
        <div style={{ border:'2px solid #1a3a5c', borderRadius:'8px', overflow:'auto', fontSize:'12px' }}>
          {/* KOP */}
          <KopFormulir
            judulFormulir="Laporan Penggunaan Kas"
            rows={[
              ['No. Dok', 'MKMJ/FM/KEU/01-02'],
              ['Revisi', '01'],
              ['Tgl. Terbit', '01 Juni 2026'],
            ]}
          />

          <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'6px', gridColumn:'1/-1' }}>
              <span style={{ fontWeight:'600', color:'#444', minWidth:'130px' }}>Ref. Pengajuan Kasbon</span><span>:</span>
              <div style={{ flex:1 }}>
                <SelectKasbon
                  value={form.pengajuan_id}
                  onChange={(val)=>pilihPengajuan(val)}
                  list={siapLaporan}
                />
              </div>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontWeight:'600', color:'#444', minWidth:'130px' }}>N A M A</span><span>:</span>
              <input name="nama_pemegang" value={form.nama_pemegang} onChange={handleChange} placeholder="Nama pemegang kas" style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontWeight:'600', color:'#444', minWidth:'130px' }}>P R O Y E K</span><span>:</span>
              <div style={{ flex:1 }}>
                <SelectProyekK
                  value={form.proyek_id}
                  onChange={(val)=>setForm(prev=>({ ...prev, proyek_id: val }))}
                  list={proyekList}
                />
              </div>
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontWeight:'600', color:'#444', minWidth:'130px' }}>Periode Dari</span><span>:</span>
              <input type="date" name="periode_dari" value={form.periode_dari} onChange={handleChange} style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
            </div>
            <div style={{ display:'flex', alignItems:'center', gap:'6px' }}>
              <span style={{ fontWeight:'600', color:'#444', minWidth:'130px' }}>Periode Sampai</span><span>:</span>
              <input type="date" name="periode_sampai" value={form.periode_sampai} onChange={handleChange} style={{ ...inputStyle, padding:'5px 8px', fontSize:'12px', flex:1 }} />
            </div>
          </div>

          <div style={{ overflowX:'auto', overflowY:'auto', maxHeight:'260px' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', minWidth:'640px' }}>
              <thead style={{ position:'sticky', top:0 }}>
                <tr>{['No.','Tgl','Nama Proyek','Uraian','Kategori','Jumlah',''].map(h=><th key={h} style={thS}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {form.items.map((it,idx)=>(
                  <tr key={idx}>
                    <td style={{ ...tdS, textAlign:'center', fontWeight:'700', width:'28px' }}>{idx+1}</td>
                    <td style={{ ...tdS, padding:'3px', width:'110px' }}><input type="date" value={it.tanggal} onChange={e=>updateItem(idx,'tanggal',e.target.value)} style={inC} /></td>
                    <td style={{ ...tdS, padding:'3px' }}><input value={it.nama_proyek_text} onChange={e=>updateItem(idx,'nama_proyek_text',e.target.value)} placeholder="Opsional" style={inC} /></td>
                    <td style={{ ...tdS, padding:'3px' }}><input value={it.uraian} onChange={e=>updateItem(idx,'uraian',e.target.value)} placeholder="Uraian pengeluaran" style={inC} /></td>
                    <td style={{ ...tdS, padding:'3px', width:'150px' }}>
                      <select value={it.kategori} onChange={e=>updateItem(idx,'kategori',e.target.value)} style={{ ...inC, cursor:'pointer' }}>
                        {kategoriPengeluaran.map(k=><option key={k.val} value={k.val}>{k.label}</option>)}
                      </select>
                    </td>
                    <td style={{ ...tdS, padding:'3px', width:'120px' }}><input type="number" value={it.jumlah} onChange={e=>updateItem(idx,'jumlah',e.target.value)} placeholder="0" style={{ ...inC, textAlign:'right' }} /></td>
                    <td style={{ ...tdS, width:'28px', textAlign:'center' }}>{form.items.length>1 && <button onClick={()=>hapusItem(idx)} style={{ background:'none', border:'none', cursor:'pointer', opacity:0.4 }}>🗑️</button>}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div style={{ padding:'8px 12px', borderTop:'1px solid #ddd', borderBottom:'1px solid #ddd', background:'#fafcff' }}>
            <button onClick={tambahItem} style={{ padding:'5px 14px', background:'white', border:'1.5px dashed #2d6a9f', borderRadius:'6px', fontSize:'12px', color:'#2d6a9f', cursor:'pointer', fontWeight:'600' }}>+ Tambah Baris</button>
          </div>

          {/* Ringkasan Kasbon vs Pengeluaran */}
          <div style={{ padding:'14px 16px' }}>
            <div style={{ display:'flex', alignItems:'center', gap:'8px', marginBottom:'10px' }}>
              <span style={{ fontWeight:'700', color:'#444', minWidth:'150px', fontSize:'13px' }}>Jumlah Kasbon Diterima</span><span>:</span>
              <input type="number" name="kasbon" value={form.kasbon} onChange={handleChange} placeholder="0" style={{ ...inputStyle, width:'200px', fontWeight:'700' }} />
            </div>
            <div style={{ background:'#f8fbff', borderRadius:'8px', padding:'12px', display:'flex', flexDirection:'column', gap:'6px' }}>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:'13px' }}><span>Jumlah Pengeluaran</span><strong>{formatRp(totalPengeluaranForm)}</strong></div>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:'13px' }}><span>Kasbon</span><strong>{formatRp(form.kasbon||0)}</strong></div>
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:'14px', fontWeight:'700', borderTop:'1px solid #ddd', paddingTop:'6px', color: sisaKurangForm>=0?'#27ae60':'#e74c3c' }}>
                <span>{sisaKurangForm>=0?'Sisa Kas (dikembalikan)':'Kekurangan (perlu reimburse)'}</span>
                <span>{formatRp(Math.abs(sisaKurangForm))}</span>
              </div>
              {/* UPLOAD BUKTI */}
          <div style={{ padding:'0 16px 12px' }}>
            <div style={{ fontSize:'12px', fontWeight:'700', color:'#444', marginBottom:'8px' }}>
              📎 Lampiran Bukti Pengeluaran
            </div>

            <label style={{
              display:'flex', alignItems:'center', gap:'10px',
              padding:'10px 16px', background:'white',
              border: uploading ? '2px dashed #aaa' : '2px dashed #2d6a9f', borderRadius:'8px',
              cursor: uploading ? 'not-allowed' : 'pointer', marginBottom:'12px',
              fontSize:'12px', color: uploading ? '#aaa' : '#2d6a9f', fontWeight:'600'
              }}>
              <span style={{ fontSize:'20px' }}>{uploading ? '⏳' : '📁'}</span>
              <div>
                <div>{uploading ? 'Mengupload...' : 'Klik untuk upload foto struk / nota / bukti'}</div>
                <div style={{ fontSize:'11px', color:'#888', fontWeight:'400' }}>JPG, PNG, WEBP, PDF — Maks. 5MB per file</div>
              </div>
              <input type="file" multiple accept="image/*,.pdf" onChange={handleUploadFoto} disabled={uploading} style={{ display:'none' }} />
            </label>

            {form.fotoDokumen.length > 0 && (
              <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(100px, 1fr))', gap:'10px' }}>
                {form.fotoDokumen.map((f,i)=>(
                  <div key={i} style={{ border:'1px solid #e0e8f4', borderRadius:'8px', overflow:'hidden', position:'relative' }}>
                    {f.isImg ? (
                      <img src={f.url.startsWith('http')?f.url:`${f.url}`} alt={f.name} style={{ width:'100%', height:'80px', objectFit:'cover', display:'block' }} />
                     ) : (
                      <div style={{ width:'100%', height:'80px', background:'#f0f4f8', display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:'4px' }}>
                        <span style={{ fontSize:'24px' }}>📄</span>
                        <span style={{ fontSize:'10px', color:'#666' }}>PDF</span>
                      </div>
                    )}
                    <div style={{ padding:'4px 6px', background:'white' }}>
                      <div style={{ fontSize:'10px', fontWeight:'600', color:'#333', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }} title={f.name}>{f.name}</div>
                    </div>
                    <button onClick={()=>hapusFotoLaporan(i)} style={{
                      position:'absolute', top:'4px', right:'4px',
                      background:'rgba(0,0,0,0.5)', color:'white',
                      border:'none', borderRadius:'50%',
                      width:'18px', height:'18px', cursor:'pointer',
                      fontSize:'10px', display:'flex', alignItems:'center', justifyContent:'center'
                    }}>✕</button>
                  </div>
                ))}
              </div>
            )}
          </div>
            </div>
          </div>

          <div style={{ padding:'12px 24px', display:'flex', justifyContent:'flex-end' }}>
            <div style={{ textAlign:'center' }}>
              <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'44px' }}>Dibuat oleh,</div>
              <div style={{ borderTop:'1px solid #333', paddingTop:'4px', width:'160px' }}>
                <div style={{ fontSize:'11px', color:'#555' }}>( {user?.nama||'................................'} )</div>
                <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>{user?.role||''}</div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {/* MODAL DETAIL */}
      <Modal show={!!showDetail} onClose={()=>setShowDetail(null)} title={`Detail — ${showDetail?.no_laporan}`} size="720px"
        footer={<Btn color="abu" onClick={()=>setShowDetail(null)}>Tutup</Btn>}>
        {showDetail && (
          <div style={{ border:'2px solid #1a3a5c', borderRadius:'8px', overflow:'auto', fontSize:'12px' }}>

            {/* KOP */}
            <KopFormulir
              judulFormulir="Laporan Penggunaan Kas"
              rows={[
                ['No. Dok', 'MKMJ/FM/KEU/01-02'],
                ['Revisi', '01'],
                ['Tgl. Terbit', '01 Juni 2026'],
              ]}
            />

            {/* INFO HEADER */}
            <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd', display:'grid', gridTemplateColumns:'1fr 1fr', gap:'8px' }}>
              {[
                ['No. Laporan',   showDetail.no_laporan],
                ['Ref. Kasbon',   showDetail.no_pengajuan||'-'],
                ['Pemegang Kas',  showDetail.nama_pemegang],
                ['Proyek',        showDetail.nama_proyek||'-'],
                ['Periode',       `${showDetail.periode_dari?.split('T')[0]||'-'} s/d ${showDetail.periode_sampai?.split('T')[0]||'-'}`],
              ].map(([l,v])=>(
                <div key={l} style={{ display:'flex', alignItems:'center', gap:'6px' }}>
                  <span style={{ fontWeight:'600', color:'#444', whiteSpace:'nowrap', minWidth:'110px' }}>{l}</span>
                  <span>:</span>
                  <span style={{ flex:1 }}>{v||'-'}</span>
                </div>
              ))}
            </div>

            {/* TABEL ITEM */}
            <div style={{ overflowX:'auto' }}>
              <table style={{ width:'100%', borderCollapse:'collapse' }}>
                <thead><tr>{['No.','Tgl','Uraian','Kategori','Jumlah'].map(h=><th key={h} style={thS}>{h}</th>)}</tr></thead>
                <tbody>
                  {(showDetail.items||[]).map((it,i)=>(
                    <tr key={i}>
                      <td style={{ ...tdS, textAlign:'center' }}>{i+1}</td>
                      <td style={{ ...tdS, textAlign:'center' }}>{it.tanggal?.split('T')[0]}</td>
                      <td style={tdS}>{it.uraian}</td>
                      <td style={tdS}>{kategoriLabel(it.kategori)}</td>
                      <td style={{ ...tdS, textAlign:'right', fontWeight:'600' }}>{formatRp(it.jumlah)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* RINGKASAN */}
            <div style={{ padding:'12px 16px', borderTop:'1px solid #ddd', borderBottom:'1px solid #ddd', background:'#f8fbff' }}>
              {[['Jumlah Pengeluaran',showDetail.jumlah_pengeluaran],['Kasbon',showDetail.kasbon]].map(([l,v])=>(
                <div key={l} style={{ display:'flex', justifyContent:'space-between', fontSize:'13px', padding:'2px 0' }}><span>{l}</span><strong>{formatRp(v)}</strong></div>
              ))}
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:'14px', fontWeight:'700', borderTop:'1px solid #ddd', paddingTop:'6px', marginTop:'4px', color: Number(showDetail.sisa_kurang)>=0?'#27ae60':'#e74c3c' }}>
                <span>{Number(showDetail.sisa_kurang)>=0?'Sisa':'Kurang'}</span><span>{formatRp(Math.abs(showDetail.sisa_kurang))}</span>
              </div>
            </div>

            {/* LAMPIRAN */}
            {showDetail.lampiran?.length > 0 && (
              <div style={{ padding:'12px 16px', borderBottom:'1px solid #ddd' }}>
                <p style={{ fontSize:'12px', fontWeight:'700', color:'#1a3a5c', marginBottom:'8px' }}>📎 Lampiran Bukti</p>
                <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(100px, 1fr))', gap:'10px' }}>
                  {showDetail.lampiran.map((f,i)=>(
                    <div key={i} style={{ border:'1px solid #e0e8f4', borderRadius:'8px', overflow:'hidden', position:'relative' }}>
                      {f.isImg
                        ? <a href={f.url.startsWith('http')?f.url:`${f.url}`} target="_blank" rel="noreferrer"><img src={f.url.startsWith('http')?f.url:`${f.url}`} alt={f.name} style={{ width:'100%', height:'80px', objectFit:'cover', display:'block' }} /></a>
                        : <div style={{ width:'100%', height:'80px', background:'#f0f4f8', display:'flex', alignItems:'center', justifyContent:'center' }}><span style={{ fontSize:'24px' }}>📄</span></div>
                      }
                      <div style={{ padding:'4px 6px', fontSize:'10px', color:'#333', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }} title={f.name}>{f.name}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* TANDA TANGAN */}
            <div style={{ padding:'12px 24px', display:'flex', justifyContent:'flex-end' }}>
              <div style={{ textAlign:'center' }}>
                <div style={{ fontSize:'11px', fontWeight:'700', color:'#444', marginBottom:'44px' }}>Dibuat oleh,</div>
                <div style={{ borderTop:'1px solid #333', paddingTop:'4px', width:'160px' }}>
                  <div style={{ fontSize:'11px', color:'#555' }}>( {showDetail.nama_pemegang||'................................'} )</div>
                  <div style={{ fontSize:'11px', color:'#888', marginTop:'2px' }}>Pemegang Kas</div>
                </div>
              </div>
            </div>

          </div>
        )}
      </Modal>

      {/* MODAL APPROVE & SETTLE */}
      <Modal show={!!showApprove} onClose={()=>setShowApprove(null)} title={`✅ Setujui & Settle — ${showApprove?.no_laporan}`} size="420px"
        footer={<><Btn color="abu" onClick={()=>setShowApprove(null)} disabled={submitting}>Batal</Btn><Btn color="hijau" onClick={submitApprove} disabled={submitting}>{submitting?'⏳...':'✅ Setujui'}</Btn></>}>
        {showApprove && (
          <div style={{ display:'flex', flexDirection:'column', gap:'12px' }}>
            <div style={{ background: Number(showApprove.sisa_kurang)>=0?'#eafaf1':'#fdedec', padding:'12px', borderRadius:'8px', fontSize:'13px', fontWeight:'600', color: Number(showApprove.sisa_kurang)>=0?'#1e8449':'#c0392b' }}>
              {Number(showApprove.sisa_kurang)>=0
                ? `Sisa kas ${formatRp(showApprove.sisa_kurang)} akan dikembalikan ke rekening`
                : `Kekurangan ${formatRp(Math.abs(showApprove.sisa_kurang))} akan direimburse dari rekening`
              }
            </div>
            <FG label="Rekening Kas/Bank" required>
              <select value={kasBankApprove} onChange={e=>setKasBankApprove(e.target.value)} style={inputStyle}>
                <option value="">-- Pilih --</option>
                {kasList.map(k=><option key={k.id} value={k.id}>{k.nama} — {formatRp(k.saldo)}</option>)}
              </select>
            </FG>
          </div>
        )}
      </Modal>
    </div>
  );
}

const metodeBayarOptions = [
  { val:'cash_tag_jt',  label:'Cash / Tag. JT', kolom:'CASH / TAG. JT' },
  { val:'bank_mkmj',    label:'Bank MKMJ',      kolom:'BANK MKMJ'      },
  { val:'bank_tujuan',  label:'Bank Tujuan',    kolom:'BANK TUJUAN'    },
  { val:'transfer_bg',  label:'Transfer / BG',  kolom:'TRANSFER / BG'  },
];

// Helper: dapatkan nomor minggu ISO dari tanggal
function getWeekNumber(d) {
  const date = new Date(d);
  date.setHours(0,0,0,0);
  date.setDate(date.getDate() + 3 - (date.getDay()+6)%7);
  const week1 = new Date(date.getFullYear(),0,4);
  return 1 + Math.round(((date - week1) / 86400000 - 3 + (week1.getDay()+6)%7) / 7);
}

function TabPengeluaranAnggaran({ user }) {
  const proyekList = useProyekList();
  const [list, setList]         = useState([]);
  const [kasList, setKasList]   = useState([]);
  const [loading, setLoading]   = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const now = new Date();
  const [filter, setFilter] = useState({
    tahun: String(now.getFullYear()),
    mode: 'minggu',
    bulan: String(now.getMonth()+1),
    minggu: String(getWeekNumber(now)),
  });

  const [form, setForm] = useState({
    tanggal: tglHariIni(), penerima:'', proyek_id:'', uraian:'', jumlah:'',
    metode_bayar:'cash_tag_jt', kas_bank_id:'', tgl_pembayaran: tglHariIni(),
  });

  useEffect(() => { fetchData(); }, [filter.tahun, filter.mode, filter.bulan, filter.minggu]);
  useEffect(() => { keuanganAPI.getAllKasBank().then(r=>{ if(r.ok) setKasList(r.data.data); }); }, []);

  async function fetchData() {
    setLoading(true);
    try {
      const params = { tahun: filter.tahun, mode: filter.mode };
      if (filter.mode === 'bulan')  params.bulan  = filter.bulan;
      if (filter.mode === 'minggu') params.minggu = filter.minggu;
      const result = await keuanganAPI.getAllPengeluaranAnggaran(params);
      if (result.ok) setList(result.data.data);
    } catch(err) {}
    finally { setLoading(false); }
  }

  function handleChange(e) { setForm({...form,[e.target.name]:e.target.value}); }

  async function submitForm() {
    if (!form.penerima || !form.jumlah) { alert('⚠️ Penerima dan jumlah wajib diisi!'); return; }
    setSubmitting(true);
    try {
      const result = await keuanganAPI.createPengeluaranAnggaran({
        ...form,
        proyek_id: form.proyek_id?Number(form.proyek_id):null,
        jumlah: Number(form.jumlah),
        kas_bank_id: form.kas_bank_id?Number(form.kas_bank_id):null,
      });
      if (result.ok) {
        alert(`✅ ${result.data.message}`);
        setShowForm(false);
        setForm({ tanggal:tglHariIni(), penerima:'', proyek_id:'', uraian:'', jumlah:'', metode_bayar:'cash_tag_jt', kas_bank_id:'', tgl_pembayaran:tglHariIni() });
        fetchData();
      } else { alert(`❌ ${result.data.message}`); }
    } catch(err) { alert('❌ Gagal terhubung ke server'); }
    finally { setSubmitting(false); }
  }

  // Range tahun untuk dropdown
  const tahunOptions = [];
  for (let y = now.getFullYear()-2; y <= now.getFullYear()+1; y++) tahunOptions.push(y);

  const bulanNama = ['Januari','Februari','Maret','April','Mei','Juni','Juli','Agustus','September','Oktober','November','Desember'];

  const totalJumlah = list.reduce((s,p)=>s+Number(p.jumlah||0),0);
  const totalPerMetode = {};
  metodeBayarOptions.forEach(m => { totalPerMetode[m.val] = list.filter(p=>p.metode_bayar===m.val).reduce((s,p)=>s+Number(p.jumlah||0),0); });

  const thS = { padding:'8px 6px', fontSize:'10px', fontWeight:'700', color:'#1a3a1a', border:'1px solid #333', textAlign:'center', background:'#a9d18e', whiteSpace:'nowrap' };
  const tdS = { border:'1px solid #999', padding:'6px 8px', fontSize:'12px', textAlign:'center' };

  return (
    <div style={{ display:'flex', flexDirection:'column', gap:'16px' }}>

      {/* FILTER PERIODE */}
      <div style={{ background:'white', borderRadius:'12px', padding:'16px 20px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', display:'flex', alignItems:'center', gap:'14px', flexWrap:'wrap' }}>
        <span style={{ fontSize:'13px', fontWeight:'700', color:'#1a3a5c' }}>📅 Filter Periode:</span>

        <select value={filter.mode} onChange={e=>setFilter({...filter, mode:e.target.value})} style={{ ...inputStyle, width:'auto', minWidth:'130px' }}>
          <option value="minggu">Per Minggu</option>
          <option value="bulan">Per Bulan</option>
          <option value="tahun">Per Tahun</option>
        </select>

        <select value={filter.tahun} onChange={e=>setFilter({...filter, tahun:e.target.value})} style={{ ...inputStyle, width:'auto', minWidth:'100px' }}>
          {tahunOptions.map(y=><option key={y} value={y}>{y}</option>)}
        </select>

        {filter.mode==='bulan' && (
          <select value={filter.bulan} onChange={e=>setFilter({...filter, bulan:e.target.value})} style={{ ...inputStyle, width:'auto', minWidth:'140px' }}>
            {bulanNama.map((b,i)=><option key={i} value={i+1}>{b}</option>)}
          </select>
        )}

        {filter.mode==='minggu' && (
          <select value={filter.minggu} onChange={e=>setFilter({...filter, minggu:e.target.value})} style={{ ...inputStyle, width:'auto', minWidth:'140px' }}>
            {Array.from({length:53},(_,i)=>i+1).map(w=><option key={w} value={w}>Minggu ke-{w}</option>)}
          </select>
        )}

        <div style={{ marginLeft:'auto' }}>
          <Btn onClick={()=>setShowForm(true)}>+ Catat Pengeluaran</Btn>
        </div>
      </div>

      {/* SUMMARY CARDS PER METODE */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(5,1fr)', gap:'12px' }}>
        <div style={{ background:'linear-gradient(135deg,#1a3a5c,#2d6a9f)', borderRadius:'12px', padding:'16px', color:'white' }}>
          <div style={{ fontSize:'11px', opacity:0.85 }}>Total Periode Ini</div>
          <div style={{ fontSize:'18px', fontWeight:'700' }}>{formatRp(totalJumlah)}</div>
        </div>
        {metodeBayarOptions.map(m=>(
          <div key={m.val} style={{ background:'white', borderRadius:'12px', padding:'16px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)' }}>
            <div style={{ fontSize:'11px', color:'#888' }}>{m.label}</div>
            <div style={{ fontSize:'15px', fontWeight:'700', color:'#1a3a5c' }}>{formatRp(totalPerMetode[m.val])}</div>
          </div>
        ))}
      </div>

      {/* TABEL FORMAT ASLI */}
      {loading ? <LoadingSpinner pesan="Memuat laporan..." /> : (
        <div style={{ background:'white', borderRadius:'12px', padding:'16px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', overflowX:'auto' }}>
          <div style={{ textAlign:'center', marginBottom:'12px' }}>
            <h3 style={{ fontSize:'15px', fontWeight:'700', color:'#1a3a5c', margin:0 }}>LAPORAN PENGELUARAN ANGGARAN PT MKMJ</h3>
            <p style={{ fontSize:'12px', color:'#666', margin:'2px 0 0' }}>
              {filter.mode==='minggu' ? `Minggu ke-${filter.minggu} Tahun ${filter.tahun}` :
               filter.mode==='bulan'  ? `${bulanNama[Number(filter.bulan)-1]} ${filter.tahun}` :
               `Tahun ${filter.tahun}`}
            </p>
          </div>

          {list.length === 0 ? (
            <EmptyState icon="📋" judul="Belum ada data" sub="Belum ada pengeluaran di periode ini" />
          ) : (
            <table style={{ width:'100%', borderCollapse:'collapse', minWidth:'900px' }}>
              <thead>
                <tr>
                  <th style={{ ...thS, width:'30px' }} rowSpan={2}>NO.</th>
                  <th style={{ ...thS, minWidth:'120px' }} rowSpan={2}>PENERIMA</th>
                  <th style={{ ...thS, minWidth:'140px' }} rowSpan={2}>PROYEK</th>
                  <th style={{ ...thS, minWidth:'200px' }} rowSpan={2}>URAIAN KEGUNAAN</th>
                  <th style={{ ...thS, minWidth:'110px' }} rowSpan={2}>JUMLAH</th>
                  <th style={thS} colSpan={4}>PEMBAYARAN</th>
                  <th style={{ ...thS, minWidth:'110px' }} rowSpan={2}>TANGGAL PEMBAYARAN</th>
                </tr>
                <tr>
                  {metodeBayarOptions.map(m=><th key={m.val} style={{ ...thS, minWidth:'100px' }}>{m.kolom}</th>)}
                </tr>
              </thead>
              <tbody>
                {list.map((p,i)=>(
                  <tr key={p.id}>
                    <td style={tdS}>{i+1}</td>
                    <td style={{ ...tdS, textAlign:'left', fontWeight:'500' }}>{p.penerima}</td>
                    <td style={{ ...tdS, textAlign:'left' }}>{p.nama_proyek||'-'}</td>
                    <td style={{ ...tdS, textAlign:'left' }}>{p.uraian||'-'}</td>
                    <td style={{ ...tdS, textAlign:'right', fontWeight:'600' }}>{formatRp(p.jumlah)}</td>
                    {metodeBayarOptions.map(m=>(
                      <td key={m.val} style={{ ...tdS, textAlign:'right', fontWeight: p.metode_bayar===m.val?'700':'400', color: p.metode_bayar===m.val?'#1a3a5c':'#ccc' }}>
                        {p.metode_bayar===m.val ? formatRp(p.jumlah) : '-'}
                      </td>
                    ))}
                    <td style={tdS}>{p.tgl_pembayaran?.split('T')[0]}</td>
                  </tr>
                ))}
                {/* TOTAL */}
                <tr style={{ background:'#eafaf1', fontWeight:'700' }}>
                  <td colSpan={4} style={{ ...tdS, textAlign:'center' }}>TOTAL</td>
                  <td style={{ ...tdS, textAlign:'right', color:'#1e8449' }}>{formatRp(totalJumlah)}</td>
                  {metodeBayarOptions.map(m=>(
                    <td key={m.val} style={{ ...tdS, textAlign:'right', color:'#1e8449' }}>{formatRp(totalPerMetode[m.val])}</td>
                  ))}
                  <td style={tdS}></td>
                </tr>
              </tbody>
            </table>
          )}
        </div>
      )}

      {/* MODAL FORM */}
      <Modal show={showForm} onClose={()=>setShowForm(false)} title="📋 Catat Pengeluaran Anggaran"
        footer={<><Btn color="abu" onClick={()=>setShowForm(false)} disabled={submitting}>Batal</Btn><Btn onClick={submitForm} disabled={submitting}>{submitting?'⏳...':'✅ Simpan'}</Btn></>}>
        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'14px' }}>
          <FG label="Tanggal" required><input type="date" name="tanggal" value={form.tanggal} onChange={handleChange} style={inputStyle} /></FG>
          <FG label="Penerima" required><input name="penerima" value={form.penerima} onChange={handleChange} placeholder="Nama penerima" style={inputStyle} /></FG>
          <FG label="Proyek">
            <select name="proyek_id" value={form.proyek_id} onChange={handleChange} style={inputStyle}>
              <option value="">-- Pilih --</option>
              {proyekList.map(p=><option key={p.id} value={p.id}>{p.nama}</option>)}
            </select>
          </FG>
          <FG label="Jumlah (Rp)" required><input type="number" name="jumlah" value={form.jumlah} onChange={handleChange} placeholder="0" style={inputStyle} /></FG>
          <FG label="Uraian Kegunaan" span><textarea name="uraian" value={form.uraian} onChange={handleChange} rows="2" style={{ ...inputStyle, resize:'vertical' }} /></FG>
          <FG label="Metode Pembayaran" required>
            <select name="metode_bayar" value={form.metode_bayar} onChange={handleChange} style={inputStyle}>
              {metodeBayarOptions.map(m=><option key={m.val} value={m.val}>{m.label}</option>)}
            </select>
          </FG>
          <FG label="Rekening Sumber (opsional)">
            <select name="kas_bank_id" value={form.kas_bank_id} onChange={handleChange} style={inputStyle}>
              <option value="">-- Tidak potong saldo --</option>
              {kasList.map(k=><option key={k.id} value={k.id}>{k.nama} — {formatRp(k.saldo)}</option>)}
            </select>
          </FG>
          <FG label="Tanggal Pembayaran"><input type="date" name="tgl_pembayaran" value={form.tgl_pembayaran} onChange={handleChange} style={inputStyle} /></FG>
        </div>
      </Modal>
    </div>
  );
}

// ============================================
// KOMPONEN UTAMA: KEUANGAN
// ============================================
function Keuangan({ user }) {
  const semuaTab = [
  { id:'ringkasan',    label:'📊 Ringkasan'             },
  { id:'kasbank',      label:'🏦 Kas & Bank'             },
  { id:'pengajuankas', label:'📝 Pengajuan Kas'          },
  { id:'laporankas',   label:'📄 Laporan Penggunaan Kas' },
  { id:'pengeluaran',  label:'📋 Laporan Pengeluaran'    },
  { id:'invoice',      label:'📄 Invoice / Faktur'       },
  { id:'anggaran',     label:'📋 Anggaran & Budget'      },
  { id:'vendor',       label:'🏢 Pembayaran Vendor'      },
  ];

  const tabDiizinkan = user?.divisi === 'direktur'
    ? semuaTab.map(t=>t.id)
    : (user?.tab_keuangan?.length ? user.tab_keuangan : ['ringkasan']);

  const tabs = semuaTab.filter(t => tabDiizinkan.includes(t.id));

  const [tabAktif, setTabAktif] = useState(tabs[0]?.id || 'ringkasan');

  return (
    <div style={{ display:'flex', flexDirection:'column' }}>
      <header style={{ display:'flex', justifyContent:'space-between', alignItems:'center', background:'white', padding:'14px 24px', borderBottom:'1px solid #e8edf2', position:'sticky', top:0, zIndex:10 }}>
        <div>
          <h1 style={{ fontSize:'18px', fontWeight:'700', color:'#1a3a5c', margin:0 }}>Keuangan & Akuntansi</h1>
          <span style={{ fontSize:'12px', color:'#888' }}>Kas & Bank · Invoice · Anggaran Proyek</span>
        </div>
        <div style={{ fontSize:'13px', color:'#666' }}>👤 {user?.nama} — {user?.role}</div>
      </header>

      <div style={{ padding:'24px', display:'flex', flexDirection:'column', gap:'20px' }}>
        {/* TAB BAR */}
        <div style={{ display:'flex', gap:'8px', background:'white', padding:'8px', borderRadius:'12px', boxShadow:'0 2px 8px rgba(0,0,0,0.06)', flexWrap:'wrap' }}>
          {tabs.map(t=>(
            <button key={t.id} onClick={()=>setTabAktif(t.id)} style={{
              padding:'10px 20px', border:'none', borderRadius:'8px',
              fontSize:'13px', fontWeight:'600', cursor:'pointer',
              background: tabAktif===t.id?'#1a3a5c':'transparent',
              color: tabAktif===t.id?'white':'#888',
            }}>
              {t.label}
            </button>
          ))}
        </div>

        {/* KONTEN TAB */}
        {tabAktif==='ringkasan' && <TabRingkasan />}
        {tabAktif==='kasbank'   && <TabKasBank   user={user} />}
        {tabAktif==='invoice'   && <TabInvoice   user={user} />}
        {tabAktif==='anggaran'  && <TabAnggaran  user={user} />}
        {tabAktif==='vendor' && <TabPembayaranVendor user={user} />}
        {tabAktif==='pengajuankas' && <TabPengajuanKas user={user} />}
        {tabAktif==='laporankas'   && <TabLaporanKas   user={user} />}
        {tabAktif==='pengeluaran' && <TabPengeluaranAnggaran user={user} />}
      </div>
    </div>
  );
}

export default Keuangan;
